import React, { useEffect, useState, useRef } from "react";
import style from "./DailyDrill.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurl } from "../Url";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Calendar from "../../assests/activeCalendar.png";
import TimerImage from "../../assests/Chronometer.png";
import { Doughnut } from "react-chartjs-2";
import TrophyImage from "../../assests/Trophy.png";
import { FaCheck, FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import SecondTrophyImage from "../../assests/SecondTrophy.png";
import ThirdTrophyImage from "../../assests/ThirdTrophy.png";
import FourthTrophyImage from "../../assests/FourthTrophy.png";
import HintImage from "../../assests/hint1.svg";
import HintImage2 from "../../assests/hint2.svg";
import ClockImage from "../../assests/alarm-clock.png";
import Loader from "../Loder/Loader";
import { Alert, Snackbar } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import Coins from "../../assests/Animations/CoinsGif.gif";
import Lottie from "lottie-react";
import coinsLottie from "../../Animation/Animation -Coins.json";
import { fetchUserDetails } from "../../Slices/UserSlice";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import { DndContext, closestCenter } from "@dnd-kit/core";
import leftArrow from "../../assests/LeftArrow.png"
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import CircularProgress from "@mui/material/CircularProgress";

const stripHtmlForCompare = (value) =>
  String(value ?? "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

/** Render rich option/answer HTML without wrapper tags or inline colors. */
const formatAnswerHtml = (html) =>
  String(html ?? "")
    .replace(/<p>/gi, "")
    .replace(/<\/p>/gi, "")
    .replace(/&nbsp;/g, " ")
    .replace(/\s*style=(["'])[^"']*\1/gi, "");

const isDragDropCellIncorrect = (incorrectIndexes, colIndex, rowIndex) => {
  if (!Array.isArray(incorrectIndexes)) return false;
  return incorrectIndexes.some(
    (entry) =>
      Number(entry?.column) === colIndex && Number(entry?.row) === rowIndex
  );
};

const getDragDropSummaryCardClass = (
  styleModule,
  incorrectIndexes,
  colIndex,
  rowIndex,
  cellValue,
  sentenceType
) => {
  const classes = [styleModule.cardInCell];
  if (sentenceType) classes.push(styleModule.cardInCellSentence);
  if (isDragDropCellIncorrect(incorrectIndexes, colIndex, rowIndex)) {
    classes.push(styleModule.wrongCard);
  } else if (stripHtmlForCompare(cellValue)) {
    classes.push(styleModule.correctCard);
  }
  return classes.join(" ");
};

const HIGHLIGHT_ANSWER_COLOR = "rgb(255, 122, 0)";

const normalizeHighlightAnswerHtml = (html = "") => {
  if (!html) return "";
  return String(html).replace(
    /color:\s*(#ff7a00|#FF7A00|rgb\(\s*255\s*,\s*122\s*,\s*0\s*\))/gi,
    `color: ${HIGHLIGHT_ANSWER_COLOR}`
  );
};

const getHighlightMultipleAnswers = (ranges = [], html = "") => {
  if (!ranges.length || !html) return [];
  return [normalizeHighlightAnswerHtml(html)];
};

const HIGHLIGHT_CORRECT_COLOR = "rgb(0, 223, 199)";
const HIGHLIGHT_INCORRECT_COLOR = "rgb(255, 124, 142)";

const normalizeHighlightMultipleRangeIndex = (rangeIndex = []) => {
  if (!Array.isArray(rangeIndex)) return [];

  return rangeIndex
    .map((item) => {
      if (item && typeof item === "object" && item.start != null && item.end != null) {
        return {
          start: Number(item.start),
          end: Number(item.end),
          text: String(item.text ?? ""),
        };
      }
      return null;
    })
    .filter((item) => item && item.end > item.start)
    .sort((a, b) => a.start - b.start);
};

const wrapTextRangeInNode = (doc, textNode, localStart, localEnd, color) => {
  const text = textNode.nodeValue || "";
  const before = text.slice(0, localStart);
  const middle = text.slice(localStart, localEnd);
  const after = text.slice(localEnd);
  const fragment = doc.createDocumentFragment();

  if (before) fragment.appendChild(doc.createTextNode(before));
  const span = doc.createElement("span");
  span.style.color = color;
  span.textContent = middle;
  fragment.appendChild(span);
  if (after) fragment.appendChild(doc.createTextNode(after));

  textNode.parentNode?.replaceChild(fragment, textNode);
};

const highlightRangesInHtml = (
  html = "",
  ranges = [],
  color = HIGHLIGHT_CORRECT_COLOR
) => {
  const normalizedRanges = normalizeHighlightMultipleRangeIndex(ranges);
  if (!html || !normalizedRanges.length || typeof document === "undefined") {
    return html || "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
  const wrapper = doc.body.firstElementChild;
  if (!wrapper) return html || "";

  const sortedRanges = [...normalizedRanges].sort((a, b) => b.start - a.start);

  sortedRanges.forEach(({ start, end }) => {
    const walker = doc.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT, null);
    let globalOffset = 0;
    let textNode;
    const segmentsToWrap = [];

    while ((textNode = walker.nextNode())) {
      const nodeText = textNode.nodeValue || "";
      const nodeStart = globalOffset;
      const nodeEnd = globalOffset + nodeText.length;
      globalOffset = nodeEnd;

      const rangeStart = Math.max(start, nodeStart);
      const rangeEnd = Math.min(end, nodeEnd);
      if (rangeStart >= rangeEnd) continue;

      segmentsToWrap.push({
        node: textNode,
        localStart: rangeStart - nodeStart,
        localEnd: rangeEnd - nodeStart,
      });
    }

    segmentsToWrap.reverse().forEach(({ node, localStart, localEnd }) => {
      wrapTextRangeInNode(doc, node, localStart, localEnd, color);
    });
  });

  return wrapper.innerHTML;
};

const trimSpacesInColoredSpans = (html = "") => {
  if (!html || typeof document === "undefined") return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
  const wrapper = doc.body.firstElementChild;
  if (!wrapper) return html;

  wrapper.querySelectorAll("span").forEach((span) => {
    const style = span.getAttribute("style") || "";
    if (!/color\s*:/i.test(style)) return;

    const text = span.textContent || "";
    const leading = text.match(/^\s+/)?.[0] || "";
    const trailing = text.match(/\s+$/)?.[0] || "";
    const trimmed = text.replace(/^\s+|\s+$/g, "");
    if (trimmed === text) return;

    span.textContent = trimmed;
    const parent = span.parentNode;
    if (!parent) return;

    if (leading) {
      parent.insertBefore(doc.createTextNode(leading), span);
    }
    if (trailing) {
      parent.insertBefore(doc.createTextNode(trailing), span.nextSibling);
    }
  });

  return wrapper.innerHTML;
};

const removeBlackColorFromHighlightSummaryHtml = (html = "") =>
  String(html || "")
    .replace(/color:\s*rgb\(\s*0\s*,\s*0\s*,\s*0\s*\)\s*;?/gi, "")
    .replace(/color:\s*#000000?\s*;?/gi, "")
    .replace(/color:\s*black\s*;?/gi, "")
    .replace(/style="\s*;?\s*"/gi, "");

const formatSingleHighlightAnswerForSummary = (html, answerIs) => {
  const color =
    answerIs === "Correct" ? HIGHLIGHT_CORRECT_COLOR : HIGHLIGHT_INCORRECT_COLOR;
  const colored = String(html || "").replace(
    /color:\s*(#ff7a00|#FF7A00|rgb\(\s*255\s*,\s*122\s*,\s*0\s*\))/gi,
    `color: ${color}`
  );
  return removeBlackColorFromHighlightSummaryHtml(
    trimSpacesInColoredSpans(colored)
  );
};

const formatHighlightMultipleAnswerForSummary = (html, incorrectIndex) => {
  let result = String(html || "").replace(
    /color:\s*(#ff7a00|#FF7A00|rgb\(\s*255\s*,\s*122\s*,\s*0\s*\))/gi,
    `color: ${HIGHLIGHT_CORRECT_COLOR}`
  );
  const incorrectRanges = normalizeHighlightMultipleRangeIndex(incorrectIndex);
  if (incorrectRanges.length > 0) {
    result = highlightRangesInHtml(
      result,
      incorrectRanges,
      HIGHLIGHT_INCORRECT_COLOR
    );
  }
  return removeBlackColorFromHighlightSummaryHtml(
    trimSpacesInColoredSpans(result)
  );
};

const parseSentence = (sentence = "") => {
  if (!sentence) return [];
  let cleaned = sentence.trim();
  if (cleaned.toLowerCase().startsWith("<p>") && cleaned.toLowerCase().endsWith("</p>")) {
    cleaned = cleaned.slice(3, -4).trim();
  }
  cleaned = cleaned.replace(/^(?:<br\s*\/?>)+|(?:<br\s*\/?>)+$/gi, "").trim();

  const regex = /(<u>.*?<\/u>|<[a-zA-Z0-9]+[^>]*style=["'][^"']*color:\s*(?:rgb\(\s*255\s*,\s*122\s*,\s*0\s*\)|#ff7a00|#FF7A00)[^"']*["'][^>]*>.*?<\/[a-zA-Z0-9]+>)/gi;
  const parts = cleaned.split(regex);
  return parts.map((part) => {
    const trimmed = part.trim();
    let isDraggable = false;
    
    if (trimmed.startsWith("<") && trimmed.endsWith(">")) {
      if (/^<u>/i.test(trimmed) && /<\/u>$/i.test(trimmed)) {
        isDraggable = true;
      } else {
        const hasStyle = /style=["']/i.test(trimmed);
        const hasOrangeColor = /color:\s*(?:rgb\(\s*255\s*,\s*122\s*,\s*0\s*\)|#ff7a00|#FF7A00)/i.test(trimmed);
        if (hasStyle && hasOrangeColor) {
          isDraggable = true;
        }
      }
    }
    
    if (isDraggable) {
      const word = part.replace(/<[^>]+>/g, "").trim();
      return { isDraggable: true, word };
    }
    
    return { isDraggable: false, text: part };
  });
};

const DailyDrill = () => {
  const {
    finishPopup,
    setFinishPopup,
    setTimeRunning,
    finished,
    setFinished,
    timeRunning,
    setAttended,
    attended,
  } = useOutletContext();
  const location = useLocation();
  const dispatch = useDispatch();

  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);

  const [assessment, setAssessment] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentAssessment, setCurrentAssessment] = useState({});
  const [validateClicked, setValidateClicked] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [randomID, setRandomID] = useState("");
  const [result, setResult] = useState(false);
  const [assessmentData, setAssessmentData] = useState({});
  const [activeDropTarget, setActiveDropTarget] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [summaryDetail, setSummaryDetail] = useState({});
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [timeOuted, setTimeOuted] = useState(false);
  const [allotedTime, setAllotedTime] = useState(null);
  const [achievementPopup, setAchievementPopup] = useState(false);
  const [collectPopup, setCollectPopup] = useState(false);
  const [carouselData, setCarouselData] = useState([]);
  const [points, setPoints] = useState("");
  const [showHint, setShowHint] = useState(false);
  const [hintDialog, setHintDialog] = useState(false);
  const hintRef = useRef();
  const [apiError, setApiError] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [coinsAnimation,setCoinsAnimation]=useState(false)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const inputRefs = useRef({});
  const highlightRefs = useRef({});
  const quillRef = useRef();

  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [inputsDisabled, setInputsDisabled] = useState(false);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  const timerRef = useRef();
  const navigate= useNavigate() ;
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const handleSubmit = () => {
    if (allotedTime !== null && startTime !== null) {
      const timeTaken = Math.floor((Date.now() - startTime) / 1000); // Convert ms to seconds
      assessmentValidate(timeTaken);
      setStartTime(Date.now());
    }
  };

  const saveSubmitLog = async (logData) => {
    try {
      const response = await fetch(`${baseurl}/submit-log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
        },
        body: JSON.stringify({
          log_data: JSON.stringify(logData),
          log_type: "daily drill",
          user_id: USERID,
          description: "Daily drill submit log",
        }),
      });
      const data = await response.json();
      console.log("Submit log response:", data);
    } catch (error) {
      console.error("Error saving submit log:", error);
    }
  };

  const attendedCount = Object.values(assessmentData).filter(
    (data) => data.status === "attended" || data.status === "skipped"
  ).length;

  const totalCount = assessment.length;
  const progressPercentage =
    totalCount > 0 ? (attendedCount / totalCount) * 100 : 0;

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const currentDate = getCurrentDate();

  const numbers = Array.from(
    { length: assessment.length },
    (_, index) => index + 1
  );

  const handleOptionClick = (option, index) => {
    const uniqueId = currentAssessment.unique_id;
    const isMultiSelect = currentAssessment.isMultiSelect;

    setAssessmentData((prev) => {
      const prevAnswers = prev[uniqueId]?.answers || [];
      let newAnswers;

      if (isMultiSelect) {
        if (prevAnswers.includes(option)) {
          newAnswers = prevAnswers.filter((ans) => ans !== option);
        } else {
          newAnswers = [...prevAnswers, option];
        }
      } else {
        newAnswers = [option];
      }

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newAnswers,
        },
      };
    });

    setSelectedOptions((prev) => {
      if (isMultiSelect) {
        const selectedIndexes = prev[uniqueId] || [];
        return {
          ...prev,
          [uniqueId]: selectedIndexes.includes(index)
            ? selectedIndexes.filter((i) => i !== index)
            : [...selectedIndexes, index],
        };
      } else {
        return {
          ...prev,
          [uniqueId]: [index],
        };
      }
    });
  };

  const handleInputChange = (index, value) => {
    const uniqueId = currentAssessment.unique_id;
    setAssessmentData((prev) => {
      const updatedAnswers = [...(prev[uniqueId]?.answers || [])];
      updatedAnswers[index] = value;
      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: updatedAnswers,
        },
      };
    });
  };

  const formatQuestionText = (text) => {
    let formattedText = text
      .replace(/<\/?p>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/(<br\s*\/?>\s*)+/g, "<br>")
      .replace(/‘|’/g, "'")
      .replace(/“|”/g, '"')
      .trim();

    console.log("Formatted Text:", formattedText);
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };
  const renderQuestionWithInputs = (question) => {
    const parts = question.split(/\[blank (\d+)\]/);
    const uniqueId = currentAssessment.unique_id;
    const status = assessmentData[uniqueId]?.status;

    return (
      <p>
        {parts.map((part, index) => {
          if (index % 2 === 1) {
            const blankIndex = parseInt(parts[index], 10) - 1;
            let inputStyle = {};

            if (status === "correct") {
              inputStyle = { color: "#00DFC7" };
            } else if (status === "incorrect") {
              inputStyle = { color: "#FF2443" };
            } else {
              inputStyle = { color: "#FF7A00" };
            }

            // Calculate dynamic width based on input value length
            const inputValue =
              assessmentData[uniqueId]?.answers[blankIndex] || "";
            const calculatedWidth = inputValue.length * 10 + 20;
            const inputWidth = `${Math.min(
              Math.max(calculatedWidth, 50),
              500
            )}px`;

            return (
              <React.Fragment key={index}>
                <input
                  type="text"
                  value={inputValue}
                  onChange={(e) =>
                    handleInputChange(blankIndex, e.target.value)
                  }
                  className={style.blankInput}
                  style={{ ...inputStyle, width: inputWidth }}
                  spellCheck="false"
                  autoCorrect="off"
                  autoComplete="off"
                  disabled={inputsDisabled}
                />
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment key={index}>
                {formatQuestionText(part)}
              </React.Fragment>
            );
          }
        })}
      </p>
    );
  };

  const renderQuestionWithDropdowns = (question, options) => {
    const uniqueId = currentAssessment.unique_id;
    const parts = question.split(/(\[dropdown-\d+\])/);

    return (
      <p>
        {parts.map((part, index) => {
          const dropdownMatch = part.match(/\[dropdown-(\d+)\]/);

          if (dropdownMatch) {
            const dropdownId = parseInt(dropdownMatch[1], 10);
            const dropdownOptions =
              options.find((option) => option.id === dropdownId)?.options || [];

            return (
              <React.Fragment key={index}>
                <select
                  value={assessmentData[uniqueId]?.answers?.[dropdownId] || ""}
                  onChange={(e) => {
                    const newAnswers = {
                      ...(assessmentData[uniqueId]?.answers || {}),
                    };
                    newAnswers[dropdownId] = e.target.value;
                    setAssessmentData((prev) => ({
                      ...prev,
                      [uniqueId]: {
                        ...prev[uniqueId],
                        answers: newAnswers,
                      },
                    }));
                  }}
                  className={style.blankDropdown}
                  disabled={inputsDisabled}
                >
                  <option disabled value="">
                    Select
                  </option>
                  {dropdownOptions.map((option, i) => (
                    <option key={i} value={option}>
                      {String(option || "")
                        .replace(/<[^>]*>/g, "")
                        .replace(/&nbsp;/gi, " ")
                        .replace(/\u00a0/g, " ")
                        .trim() || option}
                    </option>
                  ))}
                </select>
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={index}>
              {formatQuestionText(part)}
            </React.Fragment>
          );
        })}
      </p>
    );
  };

  const renderSelectAnswersQuestionWithAnswer = (question, actualAns = []) => {
    if (!question) return null;
    const answerByKey = {};
    const fallbackValues = [];

    actualAns.forEach((answerObj) => {
      Object.entries(answerObj || {}).forEach(([rawKey, rawValue]) => {
        const value = String(rawValue ?? "").trim();
        fallbackValues.push(value);
        const numericKey = Number(rawKey);
        if (!Number.isNaN(numericKey)) {
          answerByKey[numericKey] = value;
        }
      });
    });

    let fallbackIndex = 0;
    const filledQuestion = question.replace(
      /\[dropdown-(\d+)\]/g,
      (_, dropdownNo) => {
        const key = Number(dropdownNo);
        const mappedAnswer =
          answerByKey[key] ??
          answerByKey[key - 1] ??
          fallbackValues[fallbackIndex++] ??
          "";
        return `<span class="${style.selectAnswerBox}">${mappedAnswer}</span>`;
      }
    );

    return (
      <div
        className={style.fillBlankAnswer}
        dangerouslySetInnerHTML={{ __html: filledQuestion }}
      />
    );
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const sourceDroppableId = result.source.droppableId;
    const destinationDroppableId = result.destination.droppableId;
    const uniqueId = currentAssessment.unique_id;

    setAssessmentData((prev) => {
      const prevAnswers = prev[uniqueId]?.answers || { left: [], right: [] };
      const prevRightOrder =
        prev[uniqueId]?.rightOrder ||
        (prevAnswers.right || []).map((_, i) => i);

      let newAnswers = { ...prevAnswers };
      let newRightOrder = [...prevRightOrder];

      if (
        sourceDroppableId.startsWith("left") &&
        destinationDroppableId.startsWith("left")
      ) {
        const items = Array.from(newAnswers.left);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        newAnswers.left = items;
      } else if (
        sourceDroppableId.startsWith("right") &&
        destinationDroppableId.startsWith("right")
      ) {
        const items = Array.from(newAnswers.right);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        newAnswers.right = items;

        const [reorderedPos] = newRightOrder.splice(result.source.index, 1);
        newRightOrder.splice(result.destination.index, 0, reorderedPos);
      }

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newAnswers,
          rightOrder: newRightOrder,
        },
      };
    });
  };

  const handleArrangeDragEnd = (event) => {
    const { active, over } = event;
    setIsDragging(false);

    if (!over || active.id === over.id) return;

    const uniqueId = currentAssessment.unique_id;
    const items = [...(assessmentData[uniqueId]?.answers || [])];

    const oldIndex = items.findIndex(
      (_, index) => `option-${index}` === active.id
    );
    const newIndex = items.findIndex(
      (_, index) => `option-${index}` === over.id
    );

    if (oldIndex !== -1 && newIndex !== -1) {
      const newItems = arrayMove(items, oldIndex, newIndex);

      setAssessmentData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newItems,
        },
      }));
    }
  };

  const SortableItem = ({ id, option, isSentenceType }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id });

    const styles = {
      transform: CSS.Transform.toString(transform),
      transition,
      touchAction: "none", // Prevents flickering
    };

    return (
      <div
        ref={setNodeRef}
        style={styles}
        {...attributes}
        {...listeners}
        className={`${style.reArrangeCard} ${
          isSentenceType ? style.reArrangeCardSentence : ""
        } ${isDragging ? style.reArrangeCardDragging : ""}`}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: String(option ?? "")
              .replace(/<p>/gi, "")
              .replace(/<\/p>/gi, "")
              .replace(/&nbsp;/g, " "),
          }}
        />
        {isDragging && <div className={style.dragIndicator}></div>}
      </div>
    );
  };

  const handleCellValueChange = (
    rowIndex,
    colIndex,
    value,
    clueID,
    clueNumber
  ) => {
    const uniqueId = currentAssessment.unique_id;

    setAssessmentData((prevData) => {
      const newAnswers =
        prevData[uniqueId]?.answers.map((row, i) =>
          row.map((cell, j) =>
            i === rowIndex && j === colIndex
              ? { ...cell, cluevalue: value.toUpperCase(), clueID, clueNumber }
              : cell
          )
        ) || [];

      return {
        ...prevData,
        [uniqueId]: {
          ...prevData[uniqueId],
          answers: newAnswers,
        },
      };
    });
    const rows = assessmentData[uniqueId]?.answers.length || 0;
    const cols = assessmentData[uniqueId]?.answers[0]?.length || 0;

    let nextRowIndex = rowIndex + 1;
    let nextColIndex = colIndex;

    if (nextRowIndex >= rows) {
      nextColIndex += 1;
      nextRowIndex = 0;
    }
    if (
      nextRowIndex < rows &&
      inputRefs.current[uniqueId]?.[nextRowIndex * cols + nextColIndex]
    ) {
      const nextInputRef =
        inputRefs.current[uniqueId][nextRowIndex * cols + nextColIndex];
      if (nextInputRef) {
        console.log("Focusing on:", nextInputRef);
        nextInputRef.focus();
      }
    }
  };
  const getBackgroundColor = (status) => {
    switch (status) {
      case "correct":
        return "#00DFC7";
      case "incorrect":
        return "#FF7C8E";
      default:
        return "transparent";
    }
  };

  const getHighlightColor = (status) => {
    switch (status) {
      case "correct":
        return "#00FFC1"; // Color for correct status
      case "incorrect":
        return "#FF7C8E"; // Color for incorrect status
      default:
        return "#FF7A00"; // Default highlight color
    }
  };

  const handleWordSelection = () => {
    if (inputsDisabled) return;

    const selection = window.getSelection();
    const selectedText = selection.toString().trim();
    const uniqueId = currentAssessment.unique_id;

    if (selectedText && assessmentData[uniqueId]) {
      const container = highlightRefs.current[uniqueId];
      const originalContent =
        assessmentData[uniqueId].originalContent || container.innerHTML;
      const contentWithoutHighlights = originalContent.replace(
        /<span class="highlighted"[^>]*>(.*?)<\/span>/g,
        "$1"
      );
      const startIndex = contentWithoutHighlights.indexOf(selectedText);

      if (startIndex !== -1) {
        const endIndex = startIndex + selectedText.length;
        const highlightedRegex = new RegExp(
          `<span class="highlighted"[^>]*>${selectedText}</span>`
        );
        const isAlreadyHighlighted = highlightedRegex.test(container.innerHTML);
        let newContent;
        if (isAlreadyHighlighted) {
          newContent = contentWithoutHighlights;
        } else {
          const highlightColor = getHighlightColor(
            assessmentData[uniqueId]?.status
          );
          const highlightedText = `<span class="highlighted" style="color: ${highlightColor}; white-space: pre-wrap;">${selectedText}</span>`;
          newContent =
            contentWithoutHighlights.slice(0, startIndex) +
            highlightedText +
            contentWithoutHighlights.slice(endIndex);
        }

        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...prev[uniqueId],
            highlightContent: newContent,
            lastSelectedText: isAlreadyHighlighted ? "" : selectedText,
          },
        }));

        selection.removeAllRanges();
      }
    }
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex + 1);
    setValidateClicked(false); // Reset validateClicked on next
    // setSubmitLoading(false);
  };

  const handleSkip = () => {
    const uniqueId = currentAssessment?.unique_id;
    if (assessmentData[uniqueId]?.status === "viewed") {
      setAssessmentData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          status: "skipped",
        },
      }));
    }

    if (uniqueId && assessmentData[uniqueId]) {
      const currentAssmnt = assessment[currentIndex];
      let resetAnswers;
      let resetHighlightContent = "";
      let resetLastSelectedText = "";
      let resetAcrossClues = [];
      let resetDownClues = [];
      let highlightMultipleContent = "";
      let resetRightOrder = [];

      if (
        currentAssmnt.type === "Match the following" ||
        currentAssmnt.type === "Match the following with image"
      ) {
        const filteredLeft = (currentAssmnt.left || []).filter(
          (leftData) => leftData.trim() !== ""
        );
        const filteredRight = (currentAssmnt.right || []).filter(
          (rightData) => rightData.trim() !== ""
        );
        resetAnswers = {
          left: filteredLeft,
          right: filteredRight,
        };
        resetRightOrder = filteredRight.map((_, i) => i);
      } else if (currentAssmnt.type === "Rearrange") {
        resetAnswers = currentAssmnt.options || [];
      } else if (currentAssmnt.type === "cross word puzzle") {
        resetAnswers = currentAssmnt.options.map((row) =>
          row.map((cell) => ({
            clueID: cell.clueID || "",
            clueNumber: cell.clueNumber,
            cluevalue: "",
            disabled: cell.cluevalue === "",
          }))
        );

        resetAcrossClues = currentAssmnt.left.map((clueObj) => ({
          id: clueObj.id,
          number: clueObj.number,
          clue: clueObj.clue,
          answer: "",
        }));
        resetDownClues = currentAssmnt.right.map((clueObj) => ({
          id: clueObj.id,
          number: clueObj.number,
          clue: clueObj.clue,
          answer: "",
        }));
      } else if (currentAssmnt.type === "highlight") {
        resetHighlightContent =
          currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          ) || "";
        resetHighlightContent =
          resetHighlightContent.replace(/<span[^>]*>(.*?)<\/span>/g, "$1") ||
          "";

        resetLastSelectedText = "";
      } else if (currentAssmnt.type === "highlight_multiple") {
        highlightMultipleContent = currentAssmnt.options.replace(
          /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
          "$1"
        );

        highlightMultipleContent = highlightMultipleContent.replace(
          /<span[^>]*>(.*?)<\/span>/g,
          "$1"
        );
        resetAnswers = [];
      } else if (currentAssmnt.type === "Drag and Drop" || currentAssmnt.type === "drag and drop_v2") {
        const updatedAnswer = currentAssmnt.answer.map((item) => {
          return {
            ...item,
            values: item.values.map(() => ""),
          };
        });
        resetAnswers = updatedAnswer;
      } else {
        resetAnswers = [];
      }

      setAssessmentData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: resetAnswers,
          rightOrder: resetRightOrder,
          highlightContent: resetHighlightContent,
          lastSelectedText: resetLastSelectedText,
          cluesAcross: resetAcrossClues,
          cluesDown: resetDownClues,
          previousRange: null,
          highlightMultipleContent: highlightMultipleContent,
          highlightMultipleRange: [],
        },
      }));
      setSelectedOptions((prev) => {
        const { [uniqueId]: _, ...rest } = prev;
        return rest;
      });
    }

    // Proceed to next question
    setCurrentIndex((prevIndex) => prevIndex + 1);
    setValidateClicked(false); // Reset validateClicked on skip
    setStartTime(Date.now());
    // setSubmitLoading(false);
  };

  const handleEndTest = () => {
    if (!finished) {
      setFinishPopup(true);
    }
  };

  const handleDragStart = (event, option) => {
    event.dataTransfer.setData("text/plain", option);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event, colIndex, rowIndex) => {
    event.preventDefault();
    const droppedValue = event.dataTransfer.getData("text/plain");

    setAssessmentData((prev) => {
      const updatedAnswers = [...prev[currentAssessment.unique_id].answers];
      updatedAnswers[colIndex].values[rowIndex] = droppedValue;

      return {
        ...prev,
        [currentAssessment.unique_id]: {
          ...prev[currentAssessment.unique_id],
          answers: updatedAnswers,
        },
      };
    });
  };

  const handleDeleteDroppedCell = (colIndex, rowIndex) => {
    setAssessmentData((prev) => {
      const updatedAnswers = [...prev[currentAssessment.unique_id].answers];
      updatedAnswers[colIndex].values[rowIndex] = ""; // Clear the dropped value

      return {
        ...prev,
        [currentAssessment.unique_id]: {
          ...prev[currentAssessment.unique_id],
          answers: updatedAnswers,
        },
      };
    });
  };

  const handleDeleteDroppedCellV2 = (colIndex, rowIndex, uniqueId) => {
    setAssessmentData((prev) => {
      const updatedAnswers = [...prev[uniqueId].answers];
      updatedAnswers[colIndex].values[rowIndex] = ""; // Clear the dropped value

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: updatedAnswers,
        },
      };
    });
  };

  const renderDragDropTableBodyV2 = ({
    columns,
    answered,
    incorrectIndexes,
    onDelete,
    uniqueId,
  }) => {
    const rowCount = columns?.[0]?.values?.length || 0;

    return [...Array(rowCount)].map((_, rowIndex) => (
      <tr key={rowIndex}>
        {columns.map((col, colIndex) => {
          const cellValue = col.values[rowIndex];
          const hasCellValue = Boolean(cellValue && cellValue.trim());

          let cardClass = style.cardInSlotV2;
          if (answered) {
            if (isDragDropCellIncorrect(incorrectIndexes, colIndex, rowIndex)) {
              cardClass += ` ${style.cardInSlotIncorrectV2}`;
            } else if (hasCellValue) {
              cardClass += ` ${style.cardInSlotCorrectV2}`;
            }
          }

          return (
            <td
              key={`${colIndex}-${rowIndex}`}
              className={style.dragTableCellV2}
            >
              <div
                className={`${style.dropSlotV2} ${
                  activeDropTarget?.colIndex === colIndex &&
                  activeDropTarget?.rowIndex === rowIndex
                    ? style.dropSlotActiveV2
                    : ""
                }`}
                onDragOver={(event) => {
                  event.preventDefault();
                  if (!answered) {
                    setActiveDropTarget({ colIndex, rowIndex });
                  }
                }}
                onDragLeave={() => {
                  if (!answered) {
                    setActiveDropTarget(null);
                  }
                }}
                onDrop={(event) => {
                  event.preventDefault();
                  setActiveDropTarget(null);
                  if (!answered) {
                    const droppedValue = event.dataTransfer.getData("text/plain");
                    if (droppedValue) {
                      setAssessmentData((prev) => {
                        const updatedAnswers = [...prev[uniqueId].answers];
                        updatedAnswers[colIndex].values[rowIndex] = droppedValue;
                        return {
                          ...prev,
                          [uniqueId]: {
                            ...prev[uniqueId],
                            answers: updatedAnswers,
                          },
                        };
                      });
                    }
                  }
                }}
              >
                {hasCellValue ? (
                  <div className={cardClass}>
                    <p>{cellValue}</p>
                    {onDelete && !answered && (
                      <AiOutlineDelete
                        onClick={() => onDelete(colIndex, rowIndex)}
                      />
                    )}
                  </div>
                ) : null}
              </div>
            </td>
          );
        })}
      </tr>
    ));
  };

  async function assessmentGet() {
    await fetch(`${baseurl}/fetch/daily/weakly/exams`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        user_id: USERID,
        date: currentDate,
        type: "daily",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          const modifiedData = data.data[0]?.questions.map(
            (question, index) => {
              const baseQuestion = {
                ...question,
                question_no: index + 1,
                mapped_skills: question.mapped_skills || [],
              };

              if (
                question.type === "Match the following" ||
                question.type === "Match the following with image"
              ) {
                return {
                  ...baseQuestion,
                  draggable: "right",
                };
              } else if (question.type === "multiple choices") {
                const isMultiSelect = question.answer.length > 1;
                return {
                  ...baseQuestion,
                  isMultiSelect,
                };
              } else if (
                question.type === "fill in the blanks" ||
                question.type === "select the answers"
              ) {
                return {
                  ...baseQuestion,
                  question: question.question.replace(/<\/p>/g, "</p><br/>"),
                  options: question.options || [], // Ensure options are included
                };
              }
              return baseQuestion;
            }
          );
          setAssessment(modifiedData);
          setRandomID(data.data[0]?.random_id);
          setAllotedTime(data.data[0]?.alloted_time || 10);
          setLoading(false);
        } else {
          if (data.description === "already attended") {
            setApiError("Already attended");
          } else {
            setApiError("No daily drill found");
          }
          setAssessment([]);
          setCurrentAssessment({});
          setRandomID("");
          setAllotedTime("");
          setLoading(false);
        }
      });
  }

  async function assessmentValidate(time_taken) {
    const questionId = currentAssessment.id
      ? currentAssessment.id.toString()
      : "";
    let answerToSend;
    if (
      currentAssessment.type === "Match the following" ||
      currentAssessment.type === "Match the following with image"
    ) {
      if (currentAssessment.draggable === "right") {
        answerToSend =
          assessmentData[currentAssessment.unique_id]?.answers?.right || [];
      } else if (currentAssessment.draggable === "left") {
        answerToSend =
          assessmentData[currentAssessment.unique_id]?.answers?.left || [];
      }
    } else if (currentAssessment.type === "cross word puzzle") {
      answerToSend = assessmentData[currentAssessment.unique_id]?.answers.map(
        (answerGroup) =>
          Array.isArray(answerGroup)
            ? answerGroup.map((answer) => ({
                clueID: answer.clueID,
                clueNumber: answer.clueNumber,
                cluevalue: answer.cluevalue,
              }))
            : answerGroup
      );
    } else if (currentAssessment.type === "highlight") {
      const highlightHtml =
        assessmentData[currentAssessment.unique_id]?.highlightContent || "";
      answerToSend = highlightHtml
        ? [normalizeHighlightAnswerHtml(highlightHtml)]
        : [];
    } else if (currentAssessment.type === "highlight_multiple") {
      const uniqueId = currentAssessment.unique_id;
      const ranges = assessmentData[uniqueId]?.highlightMultipleRange || [];
      const highlightHtml =
        assessmentData[uniqueId]?.highlightMultipleContent || "";
      answerToSend = getHighlightMultipleAnswers(ranges, highlightHtml);
    } else if (currentAssessment.type === "fill in the blanks") {
      const rawAnswers =
      assessmentData[currentAssessment.unique_id]?.answers || [];

    const cleanedAnswers = rawAnswers
      .map((ans) => (typeof ans === "string" ? ans.trim() : ""))
      .filter((ans) => ans !== "");
    const orderedBlanks = [
      ...currentAssessment.question.matchAll(/\[blank\s*(\d+)\]/g),
    ].map((m) => m[1]);
    const sortedBlanks = [...orderedBlanks].sort(
      (a, b) => Number(a) - Number(b)
    ); 
    answerToSend = sortedBlanks.map((num) => {
      const visualIndex = orderedBlanks.indexOf(num);
      return visualIndex >= 0 ? cleanedAnswers[visualIndex] || "" : "";
  });
    } else if (currentAssessment.type === "select the answers") {
      const answersObj =
        assessmentData[currentAssessment.unique_id]?.answers || {};
      answerToSend =
        Object.values(answersObj).length > 0 ? Object.values(answersObj) : [];
    } else {
      answerToSend = assessmentData[currentAssessment.unique_id]?.answers || [];
    }

    console.log(currentAssessment, "currentAssessment");

    // console.log("Assessment-Data",[assessmentData[currentAssessment.unique_id]?.highlightContent],currentAssessment.type,[assessmentData[currentAssessment.unique_id]?.highlightMultipleContent]);

    let optValue = [];

    if (
      currentAssessment.type === "highlight" ||
      currentAssessment.type === "highlight_multiple"
    ) {
      optValue = Array.isArray(currentAssessment.options)
        ? currentAssessment.options
        : currentAssessment.options
        ? [currentAssessment.options]
        : [];
    } else if (
      currentAssessment.type === "select the answers" ||
      currentAssessment.type === "multiple choices" ||
      currentAssessment.type === "Rearrange"

    ) {
      optValue = Array.isArray(currentAssessment.options)
        ? currentAssessment.options
        : [];
    } else {
      optValue = [];
    }

    await fetch(`${baseurl}/user/drill/assignment/answers/validation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
      body: JSON.stringify({
        random_id: randomID,
        organization_ID: OrgID,
        question: currentAssessment.question,
        question_id: questionId,
        user_id: USERID,
        answer: answerToSend,
        question_type: currentAssessment.type,
        sentence_type:
          currentAssessment.type === "Rearrange" ||
          currentAssessment.type === "Drag and Drop"
            ? currentAssessment.sentence_type ?? false
            : false,
        case_sensitive:
          currentAssessment.type === "fill in the blanks"
            ? currentAssessment.case_sensitive ?? false
            : false,
        append_period:
          currentAssessment.type === "Rearrange"
            ? currentAssessment.append_period ?? false
            : false,
        shuffled_answer:
          currentAssessment.type === "fill in the blanks"
            ? currentAssessment.shuffled_answer ?? false
            : false,
        options: optValue,
        unique_id: currentAssessment.unique_id,
        left: currentAssessment.left ? currentAssessment.left : [],
        right: currentAssessment.right ? currentAssessment.right : [],
        exam_type:"daily",
        mapped_skills: currentAssessment.mapped_skills ||[],
        actual_ans:
          currentAssessment.type === "cross word puzzle"
            ? currentAssessment.options
            : currentAssessment.answer,
        question_explained: currentAssessment.question_explained,
        time_taken: time_taken.toString(),
        markif_correct: "",
        markif_incorrect: "",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);

        if (data.status === true) {
          if (!attended) {
            setAttended(true);
          }
          const rawIncorrectIndex =
            data.incorrect_index ||
            data.data?.incorrect_index ||
            data.data?.validation_result?.[0]?.incorrect_index ||
            [];
          const normalizedIncorrectIndex =
            currentAssessment.type === "highlight_multiple"
              ? normalizeHighlightMultipleRangeIndex(rawIncorrectIndex)
              : rawIncorrectIndex;

          setAssessmentData((prev) => ({
            ...prev,
            [currentAssessment.unique_id]: {
              ...prev[currentAssessment.unique_id],
              status: "attended",
              answered: true,
              ...(normalizedIncorrectIndex.length > 0 && {
                incorrect_index: normalizedIncorrectIndex,
              }),
            },
          }));
          setInputsDisabled(true);
        } else {
          setAttended(false);
          setValidateClicked(false);
        }
        // setSubmitLoading(false); // Stop loader on success
      })
      .catch((error) => {
        console.error("API call failed:", error);
        setValidateClicked(false); // Fallback for failed request
        // setSubmitLoading(false); // Stop loader on error
        setSubmitError(true); // Show error snackbar
      });
  }

  async function assessmentSummary() {
    const timeTaken =
      timeLeft > 0
        ? (allotedTime * 60 - timeLeft).toString()
        : (allotedTime * 60).toString();
    const skippedQuestions = Object.entries(assessmentData)
      .filter(([, value]) => value.status === "skipped")
      .map(([uniqueId]) => uniqueId);

    const skippedData = skippedQuestions.map((uniqueId) => {
      const assessmentItem = assessment.find(
        (item) => item.unique_id === uniqueId
      );
      console.log("Skipped Question:", {
        unique_id: assessmentItem.unique_id,
        question_id: assessmentItem.id,
        mapped_skills: assessmentItem.mapped_skills,
      });

      const {
        comment_by_learner,
        comment_by_mentor,
        comment_by_other,
        publish_status,
        generation,
        answer,
        options,
        id,
        type,
        ...filteredAssessmentItem
      } = assessmentItem;

      return {
        ...filteredAssessmentItem,
        random_id: randomID,
        organization_ID: OrgID,
        user_id: USERID,
        time_taken: "",
        markif_correct: "",
        markif_incorrect: "",
        answer: [],
        actual_ans:
          assessmentItem.type === "cross word puzzle"
            ? assessmentItem.options
            : assessmentItem.answer,
        options:
          assessmentItem.type === "highlight" ||
          assessmentItem.type === "highlight_multiple" ||
          assessmentItem.type === "drag and drop_v2"
            ? [assessmentItem.options]
            : assessmentItem.options || [],
        question_id: assessmentItem.id,
        question_type: assessmentItem.type,
        left: assessmentItem.left || [],
        right: assessmentItem.right || [],
        mapped_skills: assessmentItem.mapped_skills || [],
      };
    });

    await fetch(`${baseurl}/drill/summary`, {
      method: "POST",
      body: JSON.stringify({
        random_id: randomID,
        user_id: USERID,
        skip: skippedData || [],
        total_time: timeTaken,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          const transformedData = {
            correctAns: data.Correct_ans?.[0]?.Correct_ans || 0,
            incorrectAns: data.Incorrect_ans?.[0]?.Incorrect_ans || 0,
            skippedQuestions:
              data.Skipped_questions?.[0]?.Skipped_questions || 0,
            totalQuestions: data.Total_questions?.[0]?.Total_questions || 0,
            data: data.data.map((item) => ({
              ...item,
              isExpand: false,
            })),
            percentage: data.percentage?.[0]?.percentage || 0,
            skill_set: data.skill_set || {},
          };
          setCarouselData(data?.awards);
          const coinsArray = data?.coins || [];
          const coinsSum = coinsArray.reduce(
            (sum, coin) => sum + Number(coin),
            0
          );
          setPoints(coinsSum);
          setTimeout(() => {
            if (data?.awards && data.awards.length > 0) {
              setAchievementPopup(true);
            }
            else{
              if (data?.coins && data?.coins>0){
                setCoinsAnimation(true);
              }
            }
          }, 1000);
          setResult(true);
          setSummaryDetail(transformedData);
          setFinishPopup(false);
        } else {
          if (timeOuted || timeLeft < 1) {
            setResult(true);
          }
        }
      });
  }

  useEffect(() => {
    assessmentGet();
  }, [location.state]);
  const handleSelectionChange = (range, oldRange, source) => {
    if (inputsDisabled) return;

    const quill = quillRef.current.getEditor();
    const uniqueId = currentAssessment.unique_id;

    if (range && range.length > 0) {
      const selectedText = quill.getText(range.index, range.length).trim();
      const currentData = assessmentData[uniqueId];
      const status = currentData.status;
      const previousRange = currentData.previousRange;
      if (
        previousRange &&
        previousRange.index === range.index &&
        previousRange.length === range.length
      ) {
        quill.formatText(range.index, range.length, "color", false);
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            previousRange: null,
            lastSelectedText: "",
            highlightContent: quill.root.innerHTML,
          },
        }));
      } else {
        if (previousRange) {
          quill.formatText(
            previousRange.index,
            previousRange.length,
            "color",
            false
          );
        }
        const highlightColor = getHighlightColor(status);
        quill.formatText(range.index, range.length, "color", highlightColor);
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            previousRange: range,
            lastSelectedText: selectedText,
            highlightContent: quill.root.innerHTML,
          },
        }));
      }
    }
  };

  const handleMultipleSelectionChange = (range, oldRange, source) => {
    if (inputsDisabled) return;

    const quill = quillRef.current.getEditor();
    const uniqueId = currentAssessment.unique_id;

    if (range && range.length > 0) {
      let selectedText = quill.getText(range.index, range.length).trim();
      selectedText = selectedText.endsWith(".")
        ? selectedText.slice(0, -1)
        : selectedText;
      if (!selectedText) return;

      const currentData = assessmentData[uniqueId];
      const highlightColor = getHighlightColor(currentData.status);
      const currentRanges = currentData.highlightMultipleRange || [];
      const existingRangeIndex = currentRanges.findIndex(
        (r) => r.index === range.index && r.length === range.length
      );

      if (existingRangeIndex !== -1) {
        quill.formatText(range.index, range.length, "color", false);

        const updatedRanges = [...currentRanges];
        updatedRanges.splice(existingRangeIndex, 1);
        const updatedContent = quill.root.innerHTML;

        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            highlightMultipleRange: updatedRanges,
            highlightMultipleContent: updatedContent,
            answers: getHighlightMultipleAnswers(updatedRanges, updatedContent),
          },
        }));
      } else {
        const overlappingRanges = currentRanges.filter(
          (r) =>
            r.index < range.index + range.length &&
            range.index < r.index + r.length
        );

        let updatedRanges = [...currentRanges];
        overlappingRanges.forEach((overlappingRange) => {
          quill.formatText(
            overlappingRange.index,
            overlappingRange.length,
            "color",
            false
          );

          updatedRanges = updatedRanges.filter(
            (r) =>
              r.index !== overlappingRange.index ||
              r.length !== overlappingRange.length
          );
        });
        quill.formatText(range.index, range.length, "color", highlightColor);
        updatedRanges.push({
          index: range.index,
          length: range.length,
          text: selectedText,
        });
        const updatedContent = quill.root.innerHTML;
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            highlightMultipleRange: updatedRanges,
            highlightMultipleContent: updatedContent,
            answers: getHighlightMultipleAnswers(updatedRanges, updatedContent),
          },
        }));
      }
    }
  };

  const handleHighlightMultipleQuillChange = (value) => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
      container.style.boxShadow = "none";
    }
    const uniqueId = assessment[currentIndex]?.unique_id;
    setAssessmentData((prev) => ({
      ...prev,
      [uniqueId]: {
        ...prev[uniqueId],
        highlightMultipleContent: value,
      },
    }));
  };

  const handleQuillChange = (value) => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
      container.style.boxShadow = "none";
    }
    const uniqueId = assessment[currentIndex]?.unique_id;
    setAssessmentData((prev) => ({
      ...prev,
      [uniqueId]: {
        ...prev[uniqueId],
        highlightContent: value,
      },
    }));
  };

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const uniqueId = currentAssessment.unique_id;
      const status = assessmentData[uniqueId]?.status;
      const previousRange = assessmentData[uniqueId]?.previousRange;
      const highlightMultipleRange =
        assessmentData[uniqueId]?.highlightMultipleRange || [];

      if (quill && status) {
        const highlightColor = getHighlightColor(status);

        if (currentAssessment.type === "highlight" && previousRange) {
          quill.formatText(
            previousRange.index,
            previousRange.length,
            "color",
            highlightColor
          );
        }
        if (
          currentAssessment.type === "highlight_multiple" &&
          highlightMultipleRange.length > 0
        ) {
          highlightMultipleRange.forEach((range) => {
            quill.formatText(
              range.index,
              range.length,
              "color",
              highlightColor
            );
          });
        }
      }
    }
  }, [assessmentData[currentAssessment.unique_id]?.status]);
  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
    }
  }, []);

  useEffect(() => {
    if (assessment.length > 0) {
      const currentAssmnt = assessment[currentIndex];
      const uniqueId = currentAssmnt?.unique_id;

      setCurrentAssessment(currentAssmnt);
      setStartTime(Date.now());
      // Check if the current question is already answered and disable inputs accordingly
      const isAnswered = assessmentData[uniqueId]?.answered;
      setInputsDisabled(isAnswered || false);

      if (!assessmentData[uniqueId]) {
        let initialAnswers;
        let initialAcrossClues = [];
        let initialDownClues = [];
        let highlightContent = "";
        let lastSelectedText = "";
        let highlightMultipleContent = "";
        let initialRightOrder = [];

        if (
          currentAssmnt.type === "Match the following" ||
          currentAssmnt.type === "Match the following with image"
        ) {
          const filteredLeft = (currentAssmnt.left || []).filter(
            (leftData) => leftData.trim() !== ""
          );
          const filteredRight = (currentAssmnt.right || []).filter(
            (rightData) => rightData.trim() !== ""
          );
          initialAnswers = {
            left: filteredLeft,
            right: filteredRight,
          };
          initialRightOrder = filteredRight.map((_, i) => i);
        } else if (currentAssmnt.type === "Rearrange") {
          initialAnswers = currentAssmnt.options || [];
        } else if (currentAssmnt.type === "cross word puzzle") {
          const grid = currentAssmnt.options.map((row) =>
            row.map((cell) => ({
              clueID: cell.clueID || "",
              clueNumber: cell.clueNumber,
              cluevalue: "",
              disabled: cell.cluevalue === "",
            }))
          );
          initialAnswers = grid;

          initialAcrossClues = currentAssmnt.left.map((clueObj) => ({
            id: clueObj.id,
            number: clueObj.number,
            clue: clueObj.clue,
            answer: "",
          }));
          initialDownClues = currentAssmnt.right.map((clueObj) => ({
            id: clueObj.id,
            number: clueObj.number,
            clue: clueObj.clue,
            answer: "",
          }));
        } else if (currentAssmnt.type === "highlight") {
          highlightContent = currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          );
          highlightContent = highlightContent.replace(
            /<span[^>]*>(.*?)<\/span>/g,
            "$1"
          );

          lastSelectedText = "";
        } else if (currentAssmnt.type === "highlight_multiple") {
          highlightMultipleContent = currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          );

          highlightMultipleContent = highlightMultipleContent.replace(
            /<span[^>]*>(.*?)<\/span>/g,
            "$1"
          );
          initialAnswers = [];
        } else if (currentAssmnt.type === "Drag and Drop" || currentAssmnt.type === "drag and drop_v2") {
          const updatedAnswer = currentAssmnt.answer.map((item) => {
            return {
              ...item,
              values: item.values.map(() => ""),
            };
          });
          initialAnswers = updatedAnswer;
        } else {
          initialAnswers = [];
        }

        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            answers: initialAnswers,
            rightOrder: initialRightOrder,
            status: "",
            explanations: "",
            cluesAcross: initialAcrossClues,
            cluesDown: initialDownClues,
            highlightContent: highlightContent,
            lastSelectedText: lastSelectedText,
            originalContent: highlightContent,
            previousRange: null,
            highlightMultipleContent: highlightMultipleContent,
            highlightMultipleRange: [],
          },
        }));
      } else if (!assessmentData[uniqueId]?.status) {
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...prev[uniqueId],
            status: "viewed",
          },
        }));
      }
    }
  }, [currentIndex, assessment, assessmentData]);

  useEffect(() => {
    console.log(
      "Timer effect triggered - allotedTime:",
      allotedTime,
      "finished:",
      finished
    );

    if (allotedTime !== null && !finished) {
      const timeInSeconds = allotedTime * 60;
      console.log("Setting timeLeft to:", timeInSeconds);
      setTimeLeft(timeInSeconds);
    }
  }, [allotedTime, finished]);

  useEffect(() => {
    // console.log("refresh timer 1");
    if (timeLeft > 0 && !finished) {
      // console.warn("refresh timer 2");
      setTimeRunning(true);
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime > 0) {
            // console.log("refresh timer 3");

            return prevTime - 1;
          } else {
            // console.log("Timer reached zero.");
            clearInterval(timerRef.current);
            setTimeRunning(false);
            setTimeOuted(true);
            if (!finished) {
              console.log("refresh timer 4");
              assessmentSummary();
            }
            return 0;
          }
        });
      }, 1000);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [timeLeft, finished]);

  useEffect(() => {
    if (allotedTime !== null && timeLeft === 0 && !finished) {
      console.warn(
        "Timer did not start correctly. Page will refresh in 3 seconds..."
      );
      // console.log("assessmentSummary");
      assessmentSummary();

      // setTimeout(() => {
      //   window.location.reload();
      // }, 3000);
    }
  }, [allotedTime, timeLeft, finished]);

  useEffect(() => {
    if (currentAssessment) {
      if (!inputRefs.current[currentAssessment.unique_id]) {
        inputRefs.current[currentAssessment.unique_id] = [];
      }
    }
  }, [currentAssessment]);

  // Handle outside click for hint dialog
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (hintRef.current && !hintRef.current.contains(event.target)) {
        setHintDialog(false);
        setShowHint(false);
      }
    };

    if (hintDialog) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hintDialog]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (timeRunning && !finished) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    const handlePopState = (event) => {
      if (timeRunning && !finished) {
        event.preventDefault();
        setFinishPopup(true);
      }
    };
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [timeRunning, finished]);

  useEffect(() => {
    const uniqueId = currentAssessment.unique_id;
    const container = highlightRefs.current[uniqueId];

    if (container) {
      const spans = container.querySelectorAll(".highlighted");
      spans.forEach((span) => {
        const newColor = getHighlightColor(assessmentData[uniqueId]?.status);
        span.style.color = newColor;
      });
    }
  }, [assessmentData[currentAssessment.unique_id]?.status]);

  return (
    <div className={style.container}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        sx={{ width: "25rem" }}
        autoHideDuration={3000}
        onClose={() => {
          setError(false);
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          Please enter answer..
        </Alert>
      </Snackbar>

      {/* Snackbar for submit error */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={submitError}
        autoHideDuration={3000}
        onClose={() => setSubmitError(false)}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          Something went wrong, please try again.
        </Alert>
      </Snackbar>

      <div className={style.assessmentSection}>
        <div className={style.header}>
          <div className={style.headerText}>
            {result?
            (
              <div>
                <img src={leftArrow} onClick={()=>navigate('/')} className={style.leftArw} alt="" />
                <span>Daily Drill</span>
              </div>
            ):<span>Daily Drill</span>}
          </div>
          <div className={style.headerIcon}>
            <img src={Calendar} alt="calendar" />
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentAssessment.question_no && !result ? (
              <div className={style.progressBarSection}>
                <div
                  className={style.progressBar}
                  style={{
                    width: "95%",
                    backgroundColor: "#8E88903D",
                    borderRadius: "2rem",
                  }}
                >
                  <div
                    style={{
                      width: `${progressPercentage}%`,
                      backgroundColor: "#595BDB",
                      height: "12px",
                      transition: "width 0.5s ease-in-out",
                      borderRadius: "1rem",
                    }}
                  ></div>
                </div>
                <div className={style.progressBarCount}>
                  <p>{`${attendedCount}/${totalCount}`}</p>
                </div>
              </div>
            ) : (
              ""
            )}
            {currentAssessment.question_no ? (
              <div className={style.body}>
                <div className={style.bodyLeft}>
                  {result ? (
                    <>
                      <div className={style.resultSection}>
                        {timeOuted ? (
                          <>
                            <div className={style.resultSectionHeder}>
                              <h4 style={{ color: "#FF2443" }}>Time's Up!</h4>
                              <p>
                                You ran out of time. Don't worry, you can try
                                again tomorrow. Practice makes perfect!
                              </p>
                            </div>
                            <div className={style.resultSectionImage}>
                              <img src={ClockImage} alt="Time Out" />
                            </div>
                            <div className={style.resultSectionBottomContent}>
                              {summaryDetail.correctAns && (
                                <>
                                  <p>You’ve scored</p>
                                  <h4>
                                    {summaryDetail.correctAns}
                                  </h4>
                                </>
                              )}
                            </div>
                          </>
                        ) : (
                          summaryDetail?.percentage !== undefined && (
                            <>
                              {summaryDetail.percentage >= 85 ? (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#D09B00" }}>
                                      Congratulations!{" "}
                                    </h4>
                                    <p>
                                      You've done an excellent job in the test.
                                      Keep up the great work.
                                    </p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img src={TrophyImage} alt="Winner" />
                                  </div>
                                </>
                              ) : summaryDetail.percentage >= 60 ? (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#00CBF4" }}>
                                      Well Done!{" "}
                                    </h4>
                                    {/* <p>
                                      You've performed well in the test. Keep up
                                      the good work.
                                    </p> */}
                                    <p>You performed well in the test.</p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img src={SecondTrophyImage} alt="Winner" />
                                  </div>
                                </>
                              ) : summaryDetail.percentage >= 40 ? (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#FF8800" }}>
                                      Good effort!
                                    </h4>
                                    <p>
                                      There's room for improvement, but you're
                                      on the right track. Keep practising.
                                    </p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img src={ThirdTrophyImage} alt="Average" />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#FF2443" }}>
                                      Don't give up!
                                    </h4>
                                    <p>
                                      With consistent practice, you can achieve
                                      your goals.
                                    </p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img
                                      src={FourthTrophyImage}
                                      alt="Try Again"
                                    />
                                  </div>
                                </>
                              )}
                              <div className={style.resultSectionBottomContent}>
                                <p>You’ve scored</p>
                                <h4>
                                  {summaryDetail.correctAns}
                                </h4>
                              </div>
                            </>
                          )
                        )}
                      </div>
                      <div className={style.resultBottom}>
                        <button
                          type="button"
                          onClick={() => navigate("/")}
                        >
                          Back
                        </button>
                      </div>
                      {summaryDetail &&
                        Object.keys(summaryDetail).length > 0 && (
                          <div className={style.finalAnswerSection}>
                            <div className={style.finalAnswerSectionHeader}>
                              <p>Answers:</p>
                            </div>
                            <div className={style.finalAnswerSectionBody}>
                              <div className={style.finalAnswerSectionBody}>
                                {summaryDetail.data?.map((item, index) => {
                                  const modifiedQuestionExplained =
                                    item.question_explained.replace(
                                      /<img/g,
                                      '<img style="width:auto; height:auto;"'
                                    );
                                  const modifiedQuestion =
                                    item.question.replace(
                                      /<img/g,
                                      '<img style="width:auto; height:auto;"'
                                    );
                                  return (
                                    <div
                                      key={index}
                                      className={`${
                                        style.finalAnswerBodyData
                                      } ${
                                        expandedIndex === index
                                          ? style.expanded
                                          : ""
                                      }`}
                                    >
                                      <div className={style.answerBodyHeader}>
                                        <div
                                          className={style.answerBodyHeaderLeft}
                                        >
                                          {item.answer_is === "Correct" ? (
                                            <FaCheck
                                              style={{ color: "#00DFC7" }}
                                            />
                                          ) : (
                                            <IoMdClose
                                              style={{ color: "#FF7C8E" }}
                                            />
                                          )}
                                          <span>{index + 1}.</span>

                                          <div className={style.answerBodyText}>
                                            {item.question_type ===
                                            "cross word puzzle" ? (
                                              item.answer &&
                                              item.answer.length > 0 ? (
                                                <div
                                                  className={
                                                    style.crossWordPuzzle
                                                  }
                                                >
                                                  {item.answer.map(
                                                    (row, rowIndex) => (
                                                      <div
                                                        key={rowIndex}
                                                        className={style.row}
                                                      >
                                                        {row.map(
                                                          (cell, colIndex) => {
                                                            const disabled =
                                                              !Array.isArray(
                                                                cell.clueID
                                                              ) ||
                                                              cell.clueID
                                                                .length === 0;
                                                            return (
                                                              <div
                                                                key={`${rowIndex}-${colIndex}`}
                                                                className={
                                                                  style.cellContainer
                                                                }
                                                              >
                                                                {!disabled && (
                                                                  <input
                                                                    type="text"
                                                                    maxLength="1"
                                                                    autoCorrect="off"
                                                                    autoComplete="off"
                                                                    spellCheck="false"
                                                                    className={
                                                                      style.activeInput
                                                                    }
                                                                    value={
                                                                      cell.cluevalue ||
                                                                      ""
                                                                    }
                                                                    readOnly
                                                                    disabled={
                                                                      cell.disabled ||
                                                                      inputsDisabled
                                                                    }
                                                                  />
                                                                )}
                                                                {cell.clueNumber && (
                                                                  <div
                                                                    className={
                                                                      style.clueNumber
                                                                    }
                                                                  >
                                                                    {
                                                                      cell.clueNumber
                                                                    }
                                                                  </div>
                                                                )}
                                                              </div>
                                                            );
                                                          }
                                                        )}
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              ) : (
                                                <p>Not attended</p>
                                              )
                                            ) : item.question_type ===
                                              "Match the following" ? (
                                              item.answer &&
                                              item.answer.length > 0 ? (
                                                <div className={style.answerBodyMatch}>
                                        {Array.from({
                                          length: Math.max(item.left.length, item.answer.length),
                                        }).map((_, index) => {
                                          const leftItem = item.left[index] || "";
                                          const answerRight = item.answer[index] || "";
                                          const isWrong = Array.isArray(item.incorrect_index) && item.incorrect_index.includes(index); 
                                          return (
                                            <div key={index} className={style.matchRow}>
                                              {leftItem && (
                                                <div className={`${style.matchRowCardLeft} ${  isWrong ? style.wrongCard : style.correctCard}`}>
                                                  <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: formatAnswerHtml(leftItem),
                                                            }}
                                                          />
                                                </div>
                                              )}
                                              {answerRight && (
                                                <div className={`${style.matchRowCardRight} ${  isWrong ? style.wrongCard : style.correctCard}`}>
                                                  <p
                                                    dangerouslySetInnerHTML={{
                                                      __html: formatAnswerHtml(answerRight),
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                              ) : (
                                                <p>Not attended</p>
                                              )
                                            ) : item.question_type ===
                                              "Match the following with image" ? (
                                              item.answer &&
                                              item.answer.length > 0 ? (
                                                <div className={style.answerBodyMatch}>
                                                  {Array.from({
                                                    length: Math.max(
                                                      (item.left || []).length,
                                                      item.answer.length
                                                    ),
                                                  }).map((_, index) => {
                                                    const leftItem =
                                                      item.left?.[index] || "";
                                                    const answerRight =
                                                      item.answer[index] || "";
                                                    const isWrong =
                                                      (Array.isArray(
                                                        item.incorrect_index
                                                      ) &&
                                                        item.incorrect_index.includes(
                                                          index
                                                        )) ||
                                                      (Array.isArray(
                                                        item.match
                                                      ) &&
                                                        item.match[index] ===
                                                          "0");
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={
                                                          style.matchRow
                                                        }
                                                      >
                                                        {leftItem && (
                                                          <div
                                                            className={`${
                                                              style.matchRowImageCard
                                                            } ${
                                                              isWrong
                                                                ? style.wrongCard
                                                                : style.correctCard
                                                            }`}
                                                          >
                                                            <img
                                                              src={leftItem}
                                                              alt={`Option ${
                                                                index + 1
                                                              }`}
                                                              width="200px"
                                                            />
                                                          </div>
                                                        )}
                                                        {answerRight && (
                                                          <div
                                                            className={`${
                                                              style.matchRowCardRight
                                                            } ${
                                                              isWrong
                                                                ? style.wrongCard
                                                                : style.correctCard
                                                            }`}
                                                          >
                                                            <p
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  formatAnswerHtml(
                                                                    answerRight
                                                                  ),
                                                              }}
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              ) : (
                                                <p>Not attended</p>
                                              )
                                            ) : item.question_type ===
                                              "Drag and Drop" ? (
                                              item.answer &&
                                              item.answer.length > 0 &&
                                              item.answer.some((col) =>
                                                col.values.some(
                                                  (value) => value !== ""
                                                )
                                              ) ? (
                                                <div
                                                  className={
                                                    style.dragContainer
                                                  }
                                                >
                                                  <div
                                                    className={
                                                      style.customTable
                                                    }
                                                  >
                                                    <div
                                                      className={
                                                        style.tableHeader
                                                      }
                                                    >
                                                      {item.answer.map(
                                                        (col, colIndex) => (
                                                          <div
                                                            key={colIndex}
                                                            className={
                                                              style.headerCell
                                                            }
                                                          >
                                                            {col.header || " "}
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                    <div
                                                      className={
                                                        style.tableBody
                                                      }
                                                    >
                                                      {[
                                                        ...Array(
                                                          item.answer[0].values
                                                            .length || 0
                                                        ),
                                                      ].map((_, rowIndex) => (
                                                        <div
                                                          className={
                                                            style.tableRow
                                                          }
                                                          key={rowIndex}
                                                        >
                                                          {item.answer.map(
                                                            (col, colIndex) => (
                                                              <div
                                                                key={`${colIndex}-${rowIndex}`}
                                                                className={
                                                                  style.tableCell
                                                                }
                                                              >
                                                                {col.values[
                                                                  rowIndex
                                                                ] ? (
                                                                  <div
                                                                    className={getDragDropSummaryCardClass(
                                                                      style,
                                                                      item.incorrect_index,
                                                                      colIndex,
                                                                      rowIndex,
                                                                      col.values[
                                                                        rowIndex
                                                                      ],
                                                                      item?.sentence_type
                                                                    )}
                                                                  >
                                                                    <span
                                                                      className={
                                                                        style.cardText
                                                                      }
                                                                      dangerouslySetInnerHTML={{ __html: col.values[rowIndex],}}
                                                                    >
                                                                    </span>
                                                                  </div>
                                                                ) : null}
                                                              </div>
                                                            )
                                                          )}
                                                        </div>
                                                      ))}
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <p>Not attended</p>
                                              )
                                            ) : item.question_type ===
                                              "drag and drop_v2" ? (
                                              item.answer &&
                                              item.answer.length > 0 &&
                                              item.answer.some((col) =>
                                                col.values.some(
                                                  (value) => value !== ""
                                                )
                                              ) ? (
                                                <div className={style.dragContainer}>
                                                  <div className={style.dragTable}>
                                                    <table className={style.dragTableV2}>
                                                      <thead>
                                                        <tr>
                                                          {item.answer.map(
                                                            (col, colIndex) => (
                                                              <th
                                                                key={colIndex}
                                                                className={
                                                                  style.dragTableHeaderV2
                                                                }
                                                              >
                                                                {col.header || " "}
                                                              </th>
                                                            )
                                                          )}
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {renderDragDropTableBodyV2({
                                                          columns: item.answer,
                                                          answered: true,
                                                          incorrectIndexes: item.incorrect_index,
                                                          uniqueId: item.unique_id,
                                                        })}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              ) : (
                                                <p>Not attended</p>
                                              )
                                            ) : item.answer &&
                                              item.answer.length > 0 ? (
                                                item.question_type ===
                                                  "highlight" ? (
                                                  <div
                                                    className={
                                                      style.answerBodyHighlightAnswer
                                                    }
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        formatSingleHighlightAnswerForSummary(
                                                          item.answer[0],
                                                          item.answer_is
                                                        ),
                                                    }}
                                                  />
                                                ) : item.question_type ===
                                                  "highlight_multiple" ? (
                                                  <div
                                                    className={
                                                      style.answerBodyHighlightAnswer
                                                    }
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        formatHighlightMultipleAnswerForSummary(
                                                          item.answer[0],
                                                          item.incorrect_index
                                                        ),
                                                    }}
                                                  />
                                                ) : item.question_type ===
                                                    "fill in the blanks" ||
                                                  item.question_type ===
                                                    "select the answers" ||
                                                  item.question_type ===
                                                    "multiple choices" ||
                                                  item.question_type ===
                                                    "Rearrange" ? (
                                                  <p>
                                                    {item.answer.map(
                                                      (ans, ansIndex) => {
                                                        const isIncorrect =
                                                          Array.isArray(
                                                            item.incorrect_index
                                                          ) &&
                                                          item.incorrect_index.includes(
                                                            ansIndex
                                                          );
                                                        return (
                                                          <span
                                                            key={ansIndex}
                                                            className={
                                                              style.answerWord
                                                            }
                                                            style={{
                                                              color: isIncorrect
                                                                ? "#FF7C8E"
                                                                : "#00DFC7",
                                                              marginRight:
                                                                "6px",
                                                              fontWeight: 500,
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                              __html: String(
                                                                ans ?? ""
                                                              )
                                                                .replace(
                                                                  /<p>/gi,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /<\/p>/gi,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /&nbsp;/g,
                                                                  " "
                                                                )
                                                                // Drop inline colors so correct/incorrect styles apply to bold
                                                                .replace(
                                                                  /\s*style=(["'])[^"']*\1/gi,
                                                                  ""
                                                                ) +
                                                              (item.question_type ===
                                                                "fill in the blanks" &&
                                                              ansIndex <
                                                                item.answer
                                                                  .length -
                                                                  1
                                                                ? ","
                                                                : ""),
                                                            }}
                                                          />
                                                        );
                                                      }
                                                    )}
                                                    {item?.append_period && <span>.</span>}
                                                  </p>
                                                
                                                ) : item.question_type === "Rewrite" ||
                                                    item.question_type === "ordinary" ? (
                                                    <p
                                                      style={{
                                                        color: item.answer_is === "Correct" ? "#00DFC7" : "#FF7C8E",
                                                      }}
                                                    >
                                                      {Array.isArray(item.answer)
                                                        ? item.answer.join(" ")
                                                        : item.answer}
                                                    </p>
                                                  ) : 
                                                 (
                                                  <p>
                                                    {" "}
                                                    {item.answer.join(" ")}
                                                  </p>
                                                )
                                            ) : (
                                              <p>Not attended</p>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className={
                                            style.answerBodyHeaderRight
                                          }
                                          onClick={() => handleToggle(index)}
                                        >
                                          {expandedIndex === index ? (
                                            <FaChevronUp />
                                          ) : (
                                            <FaChevronDown />
                                          )}
                                        </div>
                                      </div>
                                      {expandedIndex === index && (
                                        <div className={style.answerBodyData}>
                                          <div
                                            className={style.answerBodyQuestion}
                                          >
                                            <h4>Question</h4>
                                            {item.question_type ===
                                            "fill in the blanks" ? (
                                              <div
                                                className={style.inputWrapper}
                                              >
                                                <p
                                                  dangerouslySetInnerHTML={{
                                                    __html: item.question
                                                      .split(/\[blank \d+\]/)
                                                      .map(
                                                        (
                                                          part,
                                                          partIndex,
                                                          partsArray
                                                        ) => {
                                                          const inputHTML =
                                                            partIndex <
                                                            partsArray.length -
                                                              1
                                                              ? `<input autoCorrect="off" autoComplete="off" spellCheck="false" type="text" readonly style="border:none; border-bottom:1px solid; width:60px; margin:0 5px;" />`
                                                              : "";
                                                          return (
                                                            part + inputHTML
                                                          );
                                                        }
                                                      )
                                                      .join(""),
                                                  }}
                                                />
                                              </div>
                                            ) : item.question_type ===
                                              "select the answers" ? (
                                              <div
                                                className={style.inputWrapper}
                                              >
                                                <p
                                                  dangerouslySetInnerHTML={{
                                                    __html: item.question
                                                      .split(/\[dropdown-\d+\]/)
                                                      .map(
                                                        (
                                                          part,
                                                          partIndex,
                                                          partsArray
                                                        ) => {
                                                          if (
                                                            partIndex <
                                                            partsArray.length -
                                                              1
                                                          ) {
                                                            const dropdownOptions =
                                                              item.options?.[
                                                                partIndex
                                                              ]?.options || [];
                                                            const dropdownHTML = `
                                                   <select style="border: 1px solid #ccc; padding: 5px; margin: 0 5px;">
                                                      <option value="">Select an option</option>
                                                      ${dropdownOptions
                                                        .map(
                                                          (option) =>
                                                            `<option disabled value="${option}">${option}</option>`
                                                        )
                                                        .join("")}
                                                    </select>
                                                  `;
                                                            return (
                                                              part +
                                                              dropdownHTML
                                                            );
                                                          }
                                                          return part;
                                                        }
                                                      )
                                                      .join(""),
                                                  }}
                                                />
                                              </div>
                                            ) : (
                                              <p
                                                dangerouslySetInnerHTML={{
                                                  __html: modifiedQuestion,
                                                }}
                                              ></p>
                                            )}

                                            {item.question_type ===
                                              "multiple choices" &&
                                              item.options &&
                                              item.options.length > 0 && (
                                                <div
                                                  className={
                                                    style.answerBodyOptions
                                                  }
                                                >
                                                  <ul>
                                                    {item.options
                                                      .filter(
                                                        (option) =>
                                                          option.trim() !== ""
                                                      )
                                                      .map(
                                                        (
                                                          option,
                                                          optionIndex
                                                        ) => (
                                                          <li
                                                            key={optionIndex}
                                                            dangerouslySetInnerHTML={{
                                                              __html: option
                                                                .replace(
                                                                  /<p>/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /<\/p>/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                                                  "$1"
                                                                )
                                                                .replace(
                                                                  /<span[^>]*>(.*?)<\/span>/g,
                                                                  "$1"
                                                                )
                                                                .replace(
                                                                  /&nbsp;$/,
                                                                  ""
                                                                ),
                                                            }}
                                                          />
                                                        )
                                                      )}
                                                  </ul>
                                                </div>
                                              )}

                                            {item.question_type ===
                                              "Rearrange" &&
                                              item.options &&
                                              item.options.length > 0 && (
                                                <div
                                                  className={`${
                                                    style.reArrangeContainer
                                                  } ${
                                                    item?.sentence_type
                                                      ? style.reArrangeContainerSentence
                                                      : ""
                                                  }`}
                                                >
                                                  {item.options
                                                    .filter(
                                                      (option) =>
                                                        option.trim() !== ""
                                                    )
                                                    .map(
                                                      (option, optionIndex) => (
                                                        <p
                                                          className={`${
                                                            style.reArrangeAnswerCard
                                                          } ${
                                                            item?.sentence_type
                                                              ? style.reArrangeAnswerCardSentence
                                                              : ""
                                                          }`}
                                                          key={optionIndex}
                                                          dangerouslySetInnerHTML={{
                                                            __html: String(
                                                              option ?? ""
                                                            )
                                                              .replace(
                                                                /<p>/gi,
                                                                ""
                                                              )
                                                              .replace(
                                                                /<\/p>/gi,
                                                                ""
                                                              )
                                                              .replace(
                                                                /&nbsp;/g,
                                                                " "
                                                              ),
                                                          }}
                                                        />
                                                      )
                                                    )}
                                                  {item?.append_period && <span>.</span>}
                                                </div>
                                              )}

                                            {item.question_type ===
                                              "highlight" &&
                                              item.options &&
                                              item.options.length > 0 && (
                                                <div
                                                  className={
                                                    style.answerBodyOptions
                                                  }
                                                >
                                                  {/* <p
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        typeof item
                                                          .options[0] ===
                                                        "string"
                                                          ? item.options[0]
                                                              .replace(
                                                                /<p>/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /<\/p>/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /<span[^>]*>(.*?)<\/span>/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /&nbsp;$/,
                                                                ""
                                                              )
                                                          : typeof item
                                                              .options[0] ===
                                                            "object"
                                                          ? item.options[0][0]
                                                              .replace(
                                                                /<p>/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /<\/p>/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /<span[^>]*>(.*?)<\/span>/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /&nbsp;$/,
                                                                ""
                                                              )
                                                          : "",
                                                    }}
                                                  ></p> */}
                                                  <p
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        typeof item
                                                          .options[0] ===
                                                        "string"
                                                          ? item.options[0]
                                                              .replace(
                                                                /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /<span[^>]*>(.*?)<\/span>/g,
                                                                "$1"
                                                              )
                                                          : typeof item
                                                              .options[0] ===
                                                            "object"
                                                          ? item.options[0][0]
                                                              .replace(
                                                                /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /<span[^>]*>(.*?)<\/span>/g,
                                                                "$1"
                                                              )
                                                          : "",
                                                    }}
                                                  ></p>
                                                </div>
                                              )}

                                            {item.question_type ===
                                              "highlight_multiple" &&
                                              item.options &&
                                              item.options.length > 0 && (
                                                <div
                                                  className={
                                                    style.answerBodyOptions
                                                  }
                                                >
                                                  <p
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        typeof item
                                                          .options[0] ===
                                                        "string"
                                                          ? item.options[0]
                                                              .replace(
                                                                /<p>/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /<\/p>/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /<span[^>]*>(.*?)<\/span>/g,
                                                                "$1"
                                                              )
                                                              .replace(
                                                                /&nbsp;$/,
                                                                ""
                                                              )
                                                          : "",
                                                    }}
                                                  ></p>
                                                </div>
                                              )}

                                            {item.question_type ===
                                              "Match the following" &&
                                              item.left &&
                                              item.left.length > 0 && (
                                                <div
                                                  className={
                                                    style.answerBodyMatch
                                                  }
                                                >
                                                  {Array.from({
                                                    length: Math.max(
                                                      item.left.length,
                                                      item.right.length
                                                    ),
                                                  }).map((_, index) => {
                                                    const leftItem =
                                                      item.left[index] || "";
                                                    const rightItem =
                                                      item.right[index] || "";

                                                    return (
                                                      <div
                                                        key={index}
                                                        className={
                                                          style.matchRow
                                                        }
                                                      >
                                                        {leftItem && (
                                                          <div
                                                            className={
                                                              style.matchRowCardLeft
                                                            }
                                                          >
                                                            <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: leftItem,
                                                            }}
                                                          />
                                                          </div>
                                                        )}
                                                        {rightItem && (
                                                          <div
                                                            className={
                                                              style.matchRowCardRight
                                                            }
                                                          >
                                                            <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: rightItem,
                                                            }}
                                                          />
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              )}
                                            {item.question_type ===
                                              "Match the following with image" &&
                                              item.left &&
                                              item.left.length > 0 && (
                                                <div
                                                  className={
                                                    style.answerBodyMatch
                                                  }
                                                >
                                                  {Array.from({
                                                    length: Math.max(
                                                      item.left.length,
                                                      item.right.length
                                                    ),
                                                  }).map((_, index) => {
                                                    const leftItem =
                                                      item.left[index] || "";
                                                    const rightItem =
                                                      item.right[index] || "";
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={
                                                          style.matchRow
                                                        }
                                                      >
                                                        {leftItem && (
                                                          <div
                                                            className={
                                                              style.matchRowImageCard
                                                            }
                                                          >
                                                            <img
                                                              src={leftItem}
                                                              alt={`Option ${
                                                                index + 1
                                                              }`}
                                                              width="200px"
                                                            />
                                                          </div>
                                                        )}
                                                        {rightItem && (
                                                          <div
                                                            className={
                                                              style.matchRowCardRight
                                                            }
                                                          >
                                                            <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: formatAnswerHtml(rightItem),
                                                            }}
                                                          />
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              )}
                                            {item.question_type ===
                                              "Drag and Drop" &&
                                              item.options &&
                                              item.options.length > 0 && (
                                                <div
                                                  className={
                                                    style.dragContainer
                                                  }
                                                >
                                                  <div
                                                    className={`${style.dragOptionContainer} ${
                                                      item?.sentence_type
                                                        ? style.dragOptionContainerSentence
                                                        : ""
                                                    }`}
                                                  >
                                                    {item.options.map(
                                                      (option, index) => {
                                                        return (
                                                          <div
                                                            key={index}
                                                            className={`${style.dragCard} ${
                                                              item?.sentence_type
                                                                ? style.dragCardSentence
                                                                : ""
                                                            }`}
                                                          >
                                                            <p dangerouslySetInnerHTML={{ __html: option }}></p>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                          {item.answer_is !== "" ? (
                                            <div
                                              className={
                                                style.answerBodyCorrectAnswer
                                              }
                                            >
                                              <h4>Correct answer</h4>
                                              {item.question_type ===
                                                "Match the following" &&
                                              item.left &&
                                              item.left.length > 0 ? (
                                                <div
                                                  className={
                                                    style.answerBodyMatch
                                                  }
                                                >
                                                  {Array.from({
                                                    length: Math.max(
                                                      item.left.length,
                                                      item.actual_ans.length
                                                    ),
                                                  }).map((_, index) => {
                                                    const leftItem =
                                                      item.left[index] || "";
                                                    const rightItem =
                                                      item.actual_ans[index] ||
                                                      "";
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={
                                                          style.matchRow
                                                        }
                                                      >
                                                        {leftItem && (
                                                          <div
                                                            className={
                                                              style.matchRowCardLeft
                                                            }
                                                          >
                                                            <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: leftItem,
                                                            }}
                                                          />
                                                          </div>
                                                        )}
                                                        {rightItem && (
                                                          <div
                                                            className={
                                                              style.matchRowCardRight
                                                            }
                                                          >
                                                            <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: rightItem,
                                                            }}
                                                          />
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              ) : item.question_type ===
                                                "fill in the blanks" ? (
                                                <div
                                                  className={
                                                    style.answerBodyMatchbox
                                                  }
                                                >
                                                  {item.actual_ans &&
                                                  item.actual_ans.length > 0 ? (
                                                    item.actual_ans.map(
                                                      (
                                                        answerObj,
                                                        answerIndex
                                                      ) => (
                                                        <ul key={answerIndex}>
                                                          {Object.entries(
                                                            answerObj
                                                          ).map(
                                                            ([key, value]) => (
                                                              <li key={key}>
                                                                {value}
                                                              </li>
                                                            )
                                                          )}
                                                        </ul>
                                                      )
                                                    )
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.question_type ===
                                                "multiple choices" ? (
                                                <div
                                                  className={
                                                    style.answerBodyMatchbox
                                                  }
                                                >
                                                  {item.actual_ans &&
                                                  item.actual_ans.length > 0 ? (
                                                    item.actual_ans.map(
                                                      (
                                                        answerObj,
                                                        answerIndex
                                                      ) => (
                                                        <ul key={answerIndex}>
                                                          {typeof answerObj ===
                                                            "object" &&
                                                          answerObj !== null ? (
                                                            Object.entries(
                                                              answerObj
                                                            ).map(
                                                              ([
                                                                key,
                                                                value,
                                                              ]) => (
                                                                <li
                                                                  key={key}
                                                                  dangerouslySetInnerHTML={{
                                                                    __html:
                                                                      String(
                                                                        value ??
                                                                          ""
                                                                      )
                                                                        .replace(
                                                                          /<p>/gi,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /<\/p>/gi,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /&nbsp;/g,
                                                                          " "
                                                                        ),
                                                                  }}
                                                                />
                                                              )
                                                            )
                                                          ) : (
                                                            <li
                                                              dangerouslySetInnerHTML={{
                                                                __html: String(
                                                                  answerObj ??
                                                                    ""
                                                                )
                                                                  .replace(
                                                                    /<p>/gi,
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    /<\/p>/gi,
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    /&nbsp;/g,
                                                                    " "
                                                                  ),
                                                              }}
                                                            />
                                                          )}
                                                        </ul>
                                                      )
                                                    )
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.question_type ===
                                                "highlight_multiple" ? (
                                                <div
                                                  className={
                                                    style.answerBodyMatchbox
                                                  }
                                                >
                                                  {item.actual_ans &&
                                                  item.actual_ans.length > 0 ? (
                                                    item.actual_ans.map(
                                                      (
                                                        answerObj,
                                                        answerIndex
                                                      ) => (
                                                        <ul key={answerIndex}>
                                                          {typeof answerObj ===
                                                          "object" ? (
                                                            Object.entries(
                                                              answerObj
                                                            ).map(
                                                              ([
                                                                key,
                                                                value,
                                                              ]) => (
                                                                <li key={key}>
                                                                  {value}
                                                                </li>
                                                              )
                                                            )
                                                          ) : (
                                                            <li>{answerObj}</li>
                                                          )}
                                                        </ul>
                                                      )
                                                    )
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.question_type ===
                                                  "Match the following with image" &&
                                                item.left &&
                                                item.left.length > 0 ? (
                                                <div
                                                  className={
                                                    style.answerBodyMatch
                                                  }
                                                >
                                                  {Array.from({
                                                    length: Math.max(
                                                      item.left.length,
                                                      item.actual_ans.length
                                                    ),
                                                  }).map((_, index) => {
                                                    const leftItem =
                                                      item.left[index] || "";
                                                    const rightItem =
                                                      item.actual_ans[index] ||
                                                      "";
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={
                                                          style.matchRow
                                                        }
                                                      >
                                                        {leftItem && (
                                                          <div
                                                            className={
                                                              style.matchRowImageCard
                                                            }
                                                          >
                                                            <img
                                                              src={leftItem}
                                                              alt={`Option ${
                                                                index + 1
                                                              }`}
                                                              width="200px"
                                                            />
                                                          </div>
                                                        )}
                                                        {rightItem && (
                                                          <div
                                                            className={
                                                              style.matchRowCardRight
                                                            }
                                                          >
                                                            <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: formatAnswerHtml(rightItem),
                                                            }}
                                                          />
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              ) : item.question_type ===
                                                "select the answers" ? (
                                                <div
                                                  className={
                                                    style.answerBodyMatchbox
                                                  }
                                                >
                                                  {(item.actual_ans || []).flat()
                                                    .length > 0 ? (
                                                    renderSelectAnswersQuestionWithAnswer(
                                                      item.question,
                                                      (
                                                        item.actual_ans || []
                                                      ).flat()
                                                    )
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.question_type ===
                                                "Rearrange" ? (
                                                <div>
                                                  {item.actual_ans.length >
                                                  0 ? (
                                                    <div
                                                      className={`${
                                                        style.reArrangeContainer
                                                      } ${
                                                        item?.sentence_type
                                                          ? style.reArrangeContainerSentence
                                                          : ""
                                                      }`}
                                                    >
                                                      {item.actual_ans[0] &&
                                                        Object.entries(
                                                          item.actual_ans[0]
                                                        ).map(
                                                          ([key, value]) => (
                                                            <p
                                                              className={`${
                                                                style.reArrangeAnswerCard
                                                              } ${
                                                                item?.sentence_type
                                                                  ? style.reArrangeAnswerCardSentence
                                                                  : ""
                                                              }`}
                                                              key={key}
                                                              dangerouslySetInnerHTML={{
                                                                __html: String(
                                                                  value ?? ""
                                                                )
                                                                  .replace(
                                                                    /<p>/gi,
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    /<\/p>/gi,
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    /&nbsp;/g,
                                                                    " "
                                                                  ),
                                                              }}
                                                            />
                                                          )
                                                        )}
                                                        {item?.append_period && <span>.</span>}
                                                    </div>
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.question_type ===
                                                "cross word puzzle" ? (
                                                <div>
                                                  <p
                                                    style={{
                                                      textDecoration:
                                                        "underLine",
                                                    }}
                                                  >
                                                    Across
                                                  </p>
                                                  {item.left.length > 0 ? (
                                                    <div>
                                                      {item.left.map(
                                                        (value, i) => (
                                                          <p key={i}>
                                                            {value.number}.
                                                            {value.answer}
                                                          </p>
                                                        )
                                                      )}
                                                    </div>
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                  <p
                                                    style={{
                                                      textDecoration:
                                                        "underLine",
                                                    }}
                                                  >
                                                    Down
                                                  </p>
                                                  {item.right.length > 0 ? (
                                                    <div>
                                                      {item.right.map(
                                                        (value, i) => (
                                                          <p key={i}>
                                                            {value.number}.
                                                            {value.answer}
                                                          </p>
                                                        )
                                                      )}
                                                    </div>
                                                  ) : (
                                                    <p>
                                                      No correct answers
                                                      available
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.question_type ===
                                                "Drag and Drop" ? (
                                                item.actual_ans &&
                                                item.actual_ans.length > 0 &&
                                                item.actual_ans.some((col) =>
                                                  col.values.some(
                                                    (value) => value !== ""
                                                  )
                                                ) ? (
                                                  <div
                                                    className={
                                                      style.dragContainer
                                                    }
                                                  >
                                                    <div
                                                      className={
                                                        style.dragTable
                                                      }
                                                    >
                                                      <div
                                                        className={
                                                          style.customTable
                                                        }
                                                      >
                                                        <div
                                                          className={
                                                            style.tableHeader
                                                          }
                                                        >
                                                          {item.actual_ans.map(
                                                            (col, colIndex) => (
                                                              <div
                                                                key={colIndex}
                                                                className={
                                                                  style.headerCell
                                                                }
                                                              >
                                                                {col.header ||
                                                                  " "}
                                                              </div>
                                                            )
                                                          )}
                                                        </div>
                                                        <div
                                                          className={
                                                            style.tableBody
                                                          }
                                                        >
                                                          {[
                                                            ...Array(
                                                              item.actual_ans[0]
                                                                .values
                                                                .length || 0
                                                            ),
                                                          ].map(
                                                            (_, rowIndex) => (
                                                              <div
                                                                key={rowIndex}
                                                                className={
                                                                  style.tableRow
                                                                }
                                                              >
                                                                {item.actual_ans.map(
                                                                  (
                                                                    col,
                                                                    colIndex
                                                                  ) => (
                                                                    <div
                                                                      key={`${colIndex}-${rowIndex}`}
                                                                      className={
                                                                        style.tableCell
                                                                      }
                                                                    >
                                                                      {col
                                                                        .values[
                                                                        rowIndex
                                                                      ] ? (
                                                                        <div
                                                                          className={`${style.cardInCell} ${
                                                                            item?.sentence_type
                                                                              ? style.cardInCellSentence
                                                                              : ""
                                                                          }`}
                                                                        >
                                                                          <span
                                                                            className={
                                                                              style.cardText
                                                                            }
                                                                            dangerouslySetInnerHTML={{ __html: col.values[rowIndex],}}
                                                                          >
                                                                          </span>
                                                                        </div>
                                                                      ) : (
                                                                        <div
                                                                          className={
                                                                            style.emptyCell
                                                                          }
                                                                        ></div>
                                                                      )}
                                                                    </div>
                                                                  )
                                                                )}
                                                              </div>
                                                            )
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <p>No answers available</p>
                                                )
                                              ) : item.question_type === "drag and drop_v2" ? (
                                                item.actual_ans &&
                                                item.actual_ans.length > 0 ? (
                                                  (() => {
                                                    let sentences = [];
                                                    if (item.left && item.left.length > 0) {
                                                      sentences = item.left;
                                                    } else if (item.paragraphs && item.paragraphs.length > 0) {
                                                      sentences = item.paragraphs;
                                                    } else if (item.options) {
                                                      if (Array.isArray(item.options)) {
                                                        sentences = item.options;
                                                      } else if (typeof item.options === "string") {
                                                        sentences = item.options.split(/<br\s*\/?>|\n/gi).filter(Boolean);
                                                      }
                                                    }
                                                    return (
                                                      <div className={style.dragContainer}>
                                                        <div className={style.dragTable}>
                                                          <table className={style.dragTableV2}>
                                                            <thead>
                                                              <tr>
                                                                {item.actual_ans.map(
                                                                  (col, colIndex) => (
                                                                    <th
                                                                      key={colIndex}
                                                                      className={
                                                                        style.dragTableHeaderV2
                                                                      }
                                                                    >
                                                                      {col.header || " "}
                                                                    </th>
                                                                  )
                                                                )}
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {renderDragDropTableBodyV2({
                                                                columns: item.actual_ans,
                                                                answered: false,
                                                                incorrectIndexes: [],
                                                                uniqueId: item.unique_id,
                                                              })}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    );
                                                  })()
                                                ) : (
                                                  <p>No answers available</p>
                                                )
                                              ) : item.actual_ans &&
                                                item.actual_ans.length > 0 ? (
                                                <div>
                                                  {item.actual_ans.map(
                                                    (answer, answerIndex) => (
                                                      <p key={answerIndex}>
                                                        {answer}
                                                      </p>
                                                    )
                                                  )}
                                                </div>
                                              ) : (
                                                <p>No answers available</p>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {item.question_explained &&
                                          item.question_explained.trim() &&
                                          item.question_explained
                                            .replace(/<[^>]*>/g, "")
                                            .trim() ? (
                                            <div
                                              className={
                                                style.answerBodyExplanation
                                              }
                                            >
                                              <h4>Explanation</h4>
                                              <p
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    modifiedQuestionExplained,
                                                }}
                                              ></p>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                        {/* {summaryDetail &&
                        Object.keys(summaryDetail).length > 0 && (
                          <div className={style.progressLevel}>
                            <div className={style.strengthLevel}>
                              {Object.values(summaryDetail?.skill_set || {})
                                .filter(skill => skill.percentage > 45).length > 0 && (
                                  <p className={style.progressHeader}>Your Strengths:</p>
                              )}
                              {Object.values(summaryDetail?.skill_set || {})
                                .filter(skill => skill.percentage > 45)
                                .map(skill => (
                                  <div key={skill.skill_id}>
                                    <p className={style.skillName}>{skill.skill_name}</p>
                                    <div className={style.spanWithPercent}>
                                      <div className={style.spanRow}>
                                        {[...Array(10)].map((_, i) => (
                                          <span
                                            key={i}
                                            className={
                                              i < Math.round((skill.percentage / 100) * 10)
                                                ? style.filledStrength
                                                : style.empty
                                            }
                                          ></span>
                                        ))}
                                      </div>
                                      <p className={style.percentStrength}>{Math.round(skill.percentage)}%</p>
                                    </div>
                                  </div>
                                ))}
                            </div>
                            <div className={style.WeakLevel}>
                              {Object.values(summaryDetail?.skill_set || {})
                                .filter(skill => skill.percentage <= 45).length > 0 && (
                                  <p className={style.progressHeader}>You need to improve on:</p>
                              )}
                              {Object.values(summaryDetail?.skill_set || {})
                                .filter(skill => skill.percentage <= 45)
                                .map(skill => (
                                  <div key={skill.skill_id}>
                                    <p className={style.skillName}>{skill.skill_name}</p>
                                    <div className={style.spanWithPercent}>
                                      <div className={style.spanRow}>
                                        {[...Array(10)].map((_, i) => (
                                          <span
                                            key={i}
                                            className={
                                              i < Math.round((skill.percentage / 100) * 10)
                                                ? style.filledWeak
                                                : style.empty
                                            }
                                          ></span>
                                        ))}
                                      </div>
                                      <p className={style.percentWeak}>{Math.round(skill.percentage)}%</p>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )} */}
                    </>
                  ) : (
                    <div className={style.questionSection}>
                      <div className={style.questBox}>
                        <div
                          className={`${style.questionType} ${
                            currentAssessment.question_level == "easy"
                              ? style.easy
                              : currentAssessment.question_level == "medium"
                              ? style.medium
                              : style.hard
                          }`}
                        >
                          <p className={style.questionTypeP}>
                            {currentAssessment.question_level
                              ? currentAssessment.question_level
                                  .charAt(0)
                                  .toUpperCase() +
                                currentAssessment.question_level.slice(1)
                              : ""}
                          </p>
                        </div>
                      </div>
                      {/*  */}
                      <div className={style.question}>
                        <div className={style.questionLeft}>
                          <span style={{ paddingRight: "5px" }}>
                            {currentAssessment.question_no}.
                          </span>
                        </div>
                        <div className={style.questionRight}>
                          {currentAssessment.type === "fill in the blanks" ? (
                            <div className={style.inputWrapper}>
                              {renderQuestionWithInputs(
                                currentAssessment.question
                              )}
                            </div>
                          ) : currentAssessment.type ===
                            "select the answers" ? (
                            <div className={style.dropDownWrapper}>
                              {renderQuestionWithDropdowns(
                                currentAssessment.question,
                                currentAssessment.options
                              )}
                            </div>
                          ) : (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: currentAssessment.question,
                              }}
                            ></p>
                          )}
                          <div className={style.questionBody}>
                            {currentAssessment.type === "ordinary" ? (
                              <div className={style.ordinaryContainer}>
                                <div className={style.ordinarySection}>
                                  <div className={style.ordinarySectionRight}>
                                    <input
                                      spellCheck="false"
                                      autoCorrect="off"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        const uniqueId =
                                          currentAssessment.unique_id;
                                        setAssessmentData((prev) => ({
                                          ...prev,
                                          [uniqueId]: {
                                            ...prev[uniqueId],
                                            answers: [e.target.value],
                                          },
                                        }));
                                      }}
                                      value={
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers[0] || ""
                                      }
                                      disabled={inputsDisabled}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : currentAssessment.type ===
                              "multiple choices" ? (
                              <div className={style.multipleChoiceContainer}>
                                {currentAssessment.options
                                  ?.filter(
                                    (option) =>
                                      String(option)
                                        .replace(/<[^>]*>/g, "")
                                        .replace(/&nbsp;/gi, " ")
                                        .trim() !== ""
                                  )
                                  .map((option, index) => {
                                    const selectedIndexes =
                                      selectedOptions[
                                        currentAssessment.unique_id
                                      ] || [];
                                    const isSelected =
                                      selectedIndexes.includes(index);

                                    let optionClass = "";
                                    if (isSelected) {
                                      optionClass = style.selected;
                                    } else {
                                      optionClass = style.unselected;
                                    }

                                    return (
                                      <div
                                        key={index}
                                        onClick={() => {
                                          if (!inputsDisabled) {
                                            handleOptionClick(option, index);
                                          }
                                        }}
                                        className={`${style.multipleChoiceAnswer} ${optionClass}`}
                                        style={{
                                          pointerEvents: inputsDisabled
                                            ? "none"
                                            : "auto",
                                          opacity: inputsDisabled ? 0.6 : 1,
                                        }}
                                      >
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: String(option)
                                              .replace(/<p>/gi, "")
                                              .replace(/<\/p>/gi, "")
                                              .replace(/&nbsp;/g, " "),
                                          }}
                                        />
                                      </div>
                                    );
                                  })}
                              </div>
                            ) : currentAssessment.type ===
                              "Match the following" ? (
                              <div className={style.matchFollowingContainer}>
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                  {Array.from({
                                    length: Math.max(
                                      (
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers?.left || []
                                      ).length,
                                      (
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers?.right || []
                                      ).length
                                    ),
                                  }).map((_, i) => {
                                    const leftData =
                                      (assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers?.left || [])[i] || "";
                                    const rightData =
                                      (assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers?.right || [])[i] || "";

                                    const matchValue =
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.match?.[i];
                                    let cardClassName;
                                    if (matchValue === "1") {
                                      cardClassName = style.correctCard;
                                    } else if (matchValue === "0") {
                                      cardClassName = style.errorCard;
                                    } else {
                                      cardClassName = style.defaultCard;
                                    }

                                    return (
                                      <React.Fragment key={i}>
                                        <Droppable droppableId={`left-${i}`}>
                                          {(provided) => (
                                            <div
                                              className={
                                                style.matchFollowingLeft
                                              }
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {leftData && (
                                                <Draggable
                                                  draggableId={`left-${i}`}
                                                  index={i}
                                                  isDragDisabled={
                                                    currentAssessment.draggable ===
                                                    "right"
                                                  }
                                                >
                                                  {(provided, snapshot) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={`${
                                                        style.matchFollowingCard
                                                      } ${cardClassName} ${
                                                        snapshot.isDragging
                                                          ? style.matchFollowingCardDragging
                                                          : ""
                                                      }`}
                                                    >
                                                      <p
                                                        dangerouslySetInnerHTML={{
                                                          __html: leftData,
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                                </Draggable>
                                              )}
                                              {provided.placeholder}
                                            </div>
                                          )}
                                        </Droppable>

                                        <Droppable droppableId={`right-${i}`}>
                                          {(provided) => (
                                            <div
                                              className={
                                                style.matchFollowingRight
                                              }
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {rightData && (
                                                <Draggable
                                                  draggableId={`right-${i}`}
                                                  index={i}
                                                  isDragDisabled={
                                                    currentAssessment.draggable ===
                                                    "left"
                                                  }
                                                >
                                                  {(provided, snapshot) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={`${
                                                        style.matchFollowingCard
                                                      } ${cardClassName} ${
                                                        snapshot.isDragging
                                                          ? style.matchFollowingCardDragging
                                                          : ""
                                                      }`}
                                                    >
                                                      <p
                                                        dangerouslySetInnerHTML={{
                                                          __html: rightData,
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                                </Draggable>
                                              )}
                                              {provided.placeholder}
                                            </div>
                                          )}
                                        </Droppable>
                                      </React.Fragment>
                                    );
                                  })}
                                </DragDropContext>
                              </div>
                            ) : currentAssessment.type ===
                              "Match the following with image" ? (
                              <div className={style.matchFollowingContainer}>
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                  {Array.from({
                                    length: Math.max(
                                      (
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers?.left || []
                                      ).length,
                                      (
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers?.right || []
                                      ).length
                                    ),
                                  }).map((_, i) => {
                                    const leftData =
                                      (assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers?.left || [])[i] || "";
                                    const rightData =
                                      (assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers?.right || [])[i] || "";

                                    const matchValue =
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.match?.[i];
                                    let cardClassName;
                                    if (matchValue === "1") {
                                      cardClassName = style.correctCard;
                                    } else if (matchValue === "0") {
                                      cardClassName = style.errorCard;
                                    } else {
                                      cardClassName = style.defaultCard;
                                    }

                                    return (
                                      <React.Fragment key={i}>
                                        <Droppable droppableId={`left-${i}`}>
                                          {(provided) => (
                                            <div
                                              className={
                                                style.matchFollowingLeft
                                              }
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {leftData && (
                                                <Draggable
                                                  draggableId={`left-${i}`}
                                                  index={i}
                                                  isDragDisabled={
                                                    currentAssessment.draggable ===
                                                    "right"
                                                  }
                                                >
                                                  {(provided, snapshot) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={`${
                                                        style.matchFollowingImageCard
                                                      } ${cardClassName} ${
                                                        snapshot.isDragging
                                                          ? style.matchFollowingImageCardDragging
                                                          : ""
                                                      }`}
                                                    >
                                                      <img
                                                        src={leftData}
                                                        alt={`Option ${i + 1}`}
                                                      />
                                                    </div>
                                                  )}
                                                </Draggable>
                                              )}
                                              {provided.placeholder}
                                            </div>
                                          )}
                                        </Droppable>

                                        <Droppable droppableId={`right-${i}`}>
                                          {(provided) => (
                                            <div
                                              className={
                                                style.matchFollowingRight
                                              }
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {rightData && (
                                                <Draggable
                                                  draggableId={`right-${i}`}
                                                  index={i}
                                                  isDragDisabled={
                                                    currentAssessment.draggable ===
                                                    "left"
                                                  }
                                                >
                                                  {(provided, snapshot) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={`${
                                                        style.matchFollowingCard
                                                      } ${cardClassName} ${
                                                        snapshot.isDragging
                                                          ? style.matchFollowingCardDragging
                                                          : ""
                                                      }`}
                                                    >
                                                      <p
                                                        dangerouslySetInnerHTML={{
                                                          __html: rightData,
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                                </Draggable>
                                              )}
                                              {provided.placeholder}
                                            </div>
                                          )}
                                        </Droppable>
                                      </React.Fragment>
                                    );
                                  })}
                                </DragDropContext>
                              </div>
                            ) : currentAssessment.type === "Rearrange" ? (
                              <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={handleArrangeDragEnd}
                                onDragStart={() => setIsDragging(true)}
                                onDragOver={() => {}}
                              >
                                <SortableContext
                                  items={assessmentData[
                                    currentAssessment.unique_id
                                  ]?.answers.map(
                                    (_, index) => `option-${index}`
                                  )}
                                  strategy={rectSortingStrategy}
                                  disabled={false}
                                >
                                  <div
                                    className={`${style.reArrangeContainer} ${
                                      currentAssessment?.sentence_type
                                        ? style.reArrangeContainerSentence
                                        : ""
                                    } ${isDragging ? style.dragging : ""}`}
                                  >
                                    {assessmentData[
                                      currentAssessment.unique_id
                                    ]?.answers.map((option, index) => (
                                      <SortableItem
                                        key={`option-${index}`}
                                        id={`option-${index}`}
                                        option={option}
                                        isSentenceType={
                                          currentAssessment?.sentence_type
                                        }
                                      />
                                    ))}
                                    {currentAssessment?.append_period && (
                                      <p>.</p>
                                    )}
                                  </div>
                                </SortableContext>
                              </DndContext>
                            ) : currentAssessment.type ===
                              "cross word puzzle" ? (
                              <div className={style.crossWordContainer}>
                                <div className={style.crossWordPuzzle}>
                                  {assessmentData[
                                    currentAssessment.unique_id
                                  ]?.answers.map((row, rowIndex) => (
                                    <div key={rowIndex} className={style.row}>
                                      {row.map((cell, colIndex) => (
                                        <div
                                          key={`${rowIndex}-${colIndex}`}
                                          className={style.cellContainer}
                                        >
                                          {!cell.disabled && (
                                            <input
                                              type="text"
                                              maxLength="1"
                                              className={style.activeInput}
                                              value={cell.value}
                                              autoCorrect="off"
                                              autoComplete="off"
                                              spellCheck="false"
                                              onChange={(e) =>
                                                handleCellValueChange(
                                                  rowIndex,
                                                  colIndex,
                                                  e.target.value,
                                                  cell.clueID,
                                                  cell.clueNumber
                                                )
                                              }
                                              disabled={inputsDisabled}
                                              ref={(el) => {
                                                if (el) {
                                                  if (
                                                    !inputRefs.current[
                                                      currentAssessment
                                                        .unique_id
                                                    ]
                                                  ) {
                                                    inputRefs.current[
                                                      currentAssessment.unique_id
                                                    ] = [];
                                                  }
                                                  inputRefs.current[
                                                    currentAssessment.unique_id
                                                  ][
                                                    rowIndex *
                                                      (assessmentData[
                                                        currentAssessment
                                                          .unique_id
                                                      ]?.answers[0]?.length ||
                                                        0) +
                                                      colIndex
                                                  ] = el;
                                                }
                                              }}
                                            />
                                          )}
                                          {cell.clueNumber && (
                                            <div className={style.clueNumber}>
                                              {cell.clueNumber}
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  ))}
                                </div>
                                <div className={style.PuzzleQuestion}>
                                  <div className={style.QuestionAcross}>
                                    <h4>Across</h4>
                                    {assessmentData[
                                      currentAssessment.unique_id
                                    ]?.cluesAcross.map((clueObj, index) => (
                                      <div
                                        key={index}
                                        className={
                                          style.QuestionAcrossInputContainer
                                        }
                                      >
                                        <span>
                                          {clueObj.number}.{clueObj.clue}{" "}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                  <div className={style.QuestionDown}>
                                    <h4>Down</h4>
                                    {assessmentData[
                                      currentAssessment.unique_id
                                    ]?.cluesDown.map((clueObj, index) => (
                                      <div
                                        key={index}
                                        className={
                                          style.QuestionDownInputContainer
                                        }
                                      >
                                        <span>
                                          {clueObj.number}.{clueObj.clue}{" "}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            ) : currentAssessment.type === "Rewrite" ? (
                              <div className={style.ordinaryContainer}>
                                <div className={style.ordinarySection}>
                                  <div className={style.rewriteSectionRight}>
                                    <textarea
                                      className={style.textareaStyle}
                                      spellCheck="false"
                                      rows={1}
                                      value={
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers[0] || ""
                                      }
                                      onChange={(e) => {
                                        const uniqueId =
                                          currentAssessment.unique_id;
                                        const sanitizedValue = e.target.value
                                          .replace(/'|'/g, "'")
                                          .replace(/"|"/g, '"');
                                        setAssessmentData((prev) => ({
                                          ...prev,
                                          [uniqueId]: {
                                            ...prev[uniqueId],
                                            answers: [sanitizedValue],
                                          },
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : currentAssessment.type === "highlight" ? (
                              // <div className={style.highlightContainer}>
                                <div>                          
                                <ReactQuill
                                  ref={quillRef}
                                  value={
                                    assessmentData[currentAssessment?.unique_id]
                                      ?.highlightContent || ""
                                  }
                                  onChange={handleQuillChange}
                                  onChangeSelection={handleSelectionChange}
                                  modules={{
                                    toolbar: false,
                                  }}
                                  style={{
                                    width: "100%",
                                    maxHeight: "200px",
                                    border: "none !important",
                                    pointerEvents: inputsDisabled
                                      ? "none"
                                      : "auto", // Enable mouse interactions
                                    userSelect: inputsDisabled
                                      ? "none"
                                      : "text", // Enable text selection
                                  }}
                                  readOnly={true}
                                  className={style.customQuill}
                                />
                              </div>
                            ) : currentAssessment.type ===
                              "highlight_multiple" ? (
                              <ReactQuill
                                ref={quillRef}
                                value={
                                  assessmentData[currentAssessment?.unique_id]
                                    ?.highlightMultipleContent || ""
                                }
                                onChange={handleHighlightMultipleQuillChange}
                                onChangeSelection={
                                  handleMultipleSelectionChange
                                }
                                modules={{
                                  toolbar: false,
                                }}
                                style={{
                                  width: "100%",
                                  maxHeight: "200px",
                                  border: "none !important",
                                  pointerEvents: inputsDisabled
                                    ? "none"
                                    : "auto", // Enable mouse interactions
                                  userSelect: inputsDisabled ? "none" : "text", // Enable text selection
                                }}
                                readOnly={true}
                                className={style.customQuill}
                              />
                            ) : currentAssessment.type === "Drag and Drop" ? (
                              <div className={style.dragContainer}>
                                <div
                                  className={`${style.dragOptionContainer} ${
                                    currentAssessment?.sentence_type
                                      ? style.dragOptionContainerSentence
                                      : ""
                                  }`}
                                >
                                  {currentAssessment.options
                                    ?.filter((option) => option.trim() !== "")
                                    .map((option, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className={`${style.dragCard} ${
                                            currentAssessment?.sentence_type
                                              ? style.dragCardSentence
                                              : ""
                                          }`}
                                          draggable={!inputsDisabled}
                                          onDragStart={(event) =>
                                            !inputsDisabled &&
                                            handleDragStart(event, option)
                                          }
                                          style={{
                                            pointerEvents: inputsDisabled
                                              ? "none"
                                              : "auto",
                                            opacity: inputsDisabled ? 0.6 : 1,
                                          }}
                                        >
                                          <p dangerouslySetInnerHTML={{ __html: option }}></p>
                                        </div>
                                      );
                                    })}
                                </div>
                                <div className={style.dragTable}>
                                  <div className={style.customTable}>
                                    <div className={style.tableHeader}>
                                      {assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers.map((col, colIndex) => (
                                        <div
                                          key={colIndex}
                                          className={style.headerCell}
                                        >
                                          {col.header || " "}
                                        </div>
                                      ))}
                                    </div>

                                    <div className={style.tableBody}>
                                      {[
                                        ...Array(
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers[0].values.length || 0
                                        ),
                                      ].map((_, rowIndex) => (
                                        <div
                                          key={rowIndex}
                                          className={style.tableRow}
                                        >
                                          {assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers.map((col, colIndex) => (
                                            <div
                                              key={`${colIndex}-${rowIndex}`}
                                              className={style.tableCell}
                                              onDragOver={(event) =>
                                                !inputsDisabled &&
                                                handleDragOver(event)
                                              }
                                              onDrop={(event) =>
                                                !inputsDisabled &&
                                                handleDrop(
                                                  event,
                                                  colIndex,
                                                  rowIndex
                                                )
                                              }
                                              style={{
                                                pointerEvents: inputsDisabled
                                                  ? "none"
                                                  : "auto",
                                              }}
                                            >
                                              {col.values[rowIndex] ? (
                                                <div
                                                  className={`${style.cardInCell} ${
                                                    currentAssessment?.sentence_type
                                                      ? style.cardInCellSentence
                                                      : ""
                                                  }`}
                                                  draggable={false}
                                                  onDragStart={(e) =>
                                                    e.preventDefault()
                                                  }
                                                >
                                                  <span
                                                    className={style.cardText}
                                                    dangerouslySetInnerHTML={{ __html: col.values[rowIndex],}}
                                                  >
                                                  </span>
                                                  <AiOutlineDelete
                                                    className={
                                                      style.deleteButton
                                                    }
                                                    onClick={() =>
                                                      !inputsDisabled &&
                                                      handleDeleteDroppedCell(
                                                        colIndex,
                                                        rowIndex
                                                      )
                                                    }
                                                    style={{
                                                      pointerEvents:
                                                        inputsDisabled
                                                          ? "none"
                                                          : "auto",
                                                      opacity: inputsDisabled
                                                        ? 0.6
                                                        : 1,
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <div
                                                  className={style.emptyCell}
                                                ></div>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : currentAssessment.type === "drag and drop_v2" ? (
                              (() => {
                                const dragDropId = currentAssessment.unique_id;
                                const dragDropAnswered = assessmentData[dragDropId]?.answered || inputsDisabled;
                                const dragDropIncorrectIndexes = assessmentData[dragDropId]?.incorrect_index || [];
                                const answers = assessmentData[dragDropId]?.answers || [];
                                let sentences = [];
                                if (currentAssessment.left && currentAssessment.left.length > 0) {
                                  sentences = currentAssessment.left;
                                } else if (currentAssessment.paragraphs && currentAssessment.paragraphs.length > 0) {
                                  sentences = currentAssessment.paragraphs;
                                } else if (currentAssessment.options) {
                                  if (Array.isArray(currentAssessment.options)) {
                                    sentences = currentAssessment.options;
                                  } else if (typeof currentAssessment.options === "string") {
                                    sentences = currentAssessment.options.split(/<br\s*\/?>|\n/gi).filter(Boolean);
                                  }
                                }
                                const placedWords = answers.flatMap((col) => col.values || []).filter(Boolean);

                                return (
                                  <div className={style.dragContainer}>
                                    <div className={style.sentencesContainerV2}>
                                      {sentences.map((sentence, sIdx) => {
                                        const parts = parseSentence(sentence);
                                        return (
                                          <p key={sIdx} className={style.sentenceTextV2}>
                                            {parts.map((part, pIdx) => {
                                              if (part.isDraggable) {
                                                const isPlaced = placedWords.some(
                                                  (pw) => pw.trim().toLowerCase() === part.word.trim().toLowerCase()
                                                );
                                                return (
                                                  <span
                                                    key={pIdx}
                                                    className={isPlaced ? style.draggableWordPlaced : style.draggableWord}
                                                    draggable={!dragDropAnswered && !isPlaced}
                                                    onDragStart={(event) => {
                                                      if (!dragDropAnswered && !isPlaced) {
                                                        handleDragStart(event, part.word);
                                                      }
                                                    }}
                                                  >
                                                    {part.word}
                                                  </span>
                                                );
                                              }
                                              return <span key={pIdx} dangerouslySetInnerHTML={{ __html: part.text }} />;
                                            })}
                                          </p>
                                        );
                                      })}
                                    </div>

                                    <div className={style.dragTable}>
                                      <table className={style.dragTableV2}>
                                        <thead>
                                          <tr>
                                            {answers.map((col, colIndex) => (
                                              <th
                                                key={colIndex}
                                                className={style.dragTableHeaderV2}
                                              >
                                                {col.header || " "}
                                              </th>
                                            ))}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {renderDragDropTableBodyV2({
                                            columns: answers,
                                            answered: false,
                                            incorrectIndexes: dragDropIncorrectIndexes,
                                            onDelete: (colIdx, rowIdx) =>
                                              handleDeleteDroppedCellV2(colIdx, rowIdx, dragDropId),
                                            uniqueId: dragDropId,
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                );
                              })()
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={style.questionButtonSection}>
                        <div className={style.questionButtonLeft}>
                          {/* {currentAssessment.type === "highlight" &&(
                            <span>
                              *Select the text you want to highlight.
                            </span>
                          )}
                          {currentAssessment.type === "highlight_multiple" &&(
                            <span>
                              *Select all the text you think is correct.
                            </span>
                          )} */}
                          {currentAssessment.type === "Match the following" &&(
                            <span>
                              *Drag the boxes on the right to drop them next to
                              the correct match on the left.
                            </span>
                          )}
                          {currentAssessment.type === "Drag and Drop" && (
                            <span>
                              *Drag each item and drop it into the correct position.
                            </span>
                          )}
                          {currentAssessment.type === "drag and drop_v2" && (
                            <span>
                              *Drag each underlined word and drop it into the correct category box.
                            </span>
                          )}
                        </div>
                        <div
                          className={`${style.questionButtonRight} ${
                            assessmentData[currentAssessment.unique_id]
                              ?.answered || submitLoading
                              ? style.resubmitMode
                              : ""
                          }`}
                        >
                          {assessmentData[currentAssessment.unique_id]
                            ?.answered || submitLoading ? (
                            <>
                              {currentIndex !== assessment.length - 1 ? (
                                <button
                                  onClick={() => handleNext()}
                                  disabled={
                                    currentIndex === assessment.length - 1
                                  }
                                  style={{ background: "#00CBF480" }}
                                >
                                  Next
                                </button>
                              ) : null}
                              <button
                                onClick={() => {
                                  // Reset the question state to allow re-attending
                                  const uniqueId = currentAssessment.unique_id;
                                  setAssessmentData((prev) => ({
                                    ...prev,
                                    [uniqueId]: {
                                      ...prev[uniqueId],
                                      answered: false,
                                      status: "viewed",
                                    },
                                  }));
                                  setValidateClicked(false);
                                  setStartTime(Date.now());
                                  setInputsDisabled(false);
                                }}
                                style={{
                                  background: "#FF7A00",
                                  marginLeft: "10px",
                                }}
                              >
                                Amend
                              </button>
                            </>
                          ) : (
                            <div className={style.btnGrp}>
                              <div
                                className={style.skipBtn}
                                onClick={() => {
                                  if (currentIndex === assessment.length - 1) {
                                    handleEndTest();
                                  } else {
                                    handleSkip();
                                  }
                                }}
                              >
                                <p>Skip</p>
                              </div>

                              {currentAssessment?.hint && (
                                <div className={style.hintContainer}>
                                  {!showHint ? (
                                    <img
                                      src={HintImage}
                                      alt="hint"
                                      className={style.hintImage}
                                      onClick={() => {
                                        setShowHint(true);
                                        setHintDialog(true);
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className={style.hintActiveContainer}
                                      ref={hintRef}
                                    >
                                      <img
                                        src={HintImage2}
                                        alt="hint active"
                                        className={style.hintImage2}
                                        onClick={() => {
                                          setShowHint(false);
                                          setHintDialog(false);
                                        }}
                                      />
                                      {hintDialog && (
                                        <div className={style.hintDialog}>
                                          <div
                                            className={style.hintDialogContent}
                                          >
                                            {currentAssessment?.hint}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                          {!assessmentData[currentAssessment.unique_id]
                            ?.answered ? (
                            <button
                              onClick={() => {
                                const uniqueId = currentAssessment.unique_id;
                                const answers =
                                  assessmentData[uniqueId]?.answers || [];
                                const isAlreadyAnswered =
                                  assessmentData[uniqueId]?.answered;

                                console.log(
                                  "validateClicked:",
                                  validateClicked
                                );
                                console.log(
                                  "alreadyAnswered:",
                                  isAlreadyAnswered
                                );

                                if (validateClicked || isAlreadyAnswered) {
                                  console.log(
                                    "Submit prevented due to validateClicked or already answered."
                                  );
                                  return;
                                }

                                let logData = {
                                  question_id: uniqueId,
                                  question_type: currentAssessment.type,
                                  validation_conditions: {},
                                  button_state: {
                                    isDisabled:
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered || false,
                                    isValidateClicked: validateClicked,
                                    isAlreadyAnswered: isAlreadyAnswered,
                                  },
                                };

                                if (
                                  currentAssessment.type ===
                                    "Match the following" ||
                                  currentAssessment.type ===
                                    "Match the following with image"
                                ) {
                                  const rightOrder =
                                    assessmentData[uniqueId]?.rightOrder ||
                                    (answers?.right || []).map((_, i) => i);

                                  // Track by original position, not text value
                                  const areRightAnswersSame =
                                    rightOrder.length === 0 ||
                                    rightOrder.every(
                                      (pos, index) => pos === index
                                    );

                                  logData.validation_conditions = {
                                    areRightAnswersSame,
                                    rightOrder,
                                  };

                                  if (areRightAnswersSame) {
                                    setError(true);
                                    // setSubmitLoading(false); // Stop loader on error
                                    return;
                                  } else {
                                    handleSubmit();
                                    setValidateClicked(true);
                                    // setSubmitLoading(true);
                                  }
                                } else if (
                                  currentAssessment.type === "Rearrange"
                                ) {
                                  const options =
                                    currentAssessment.options.filter(
                                      (op) => op.trim() !== ""
                                    ) || [];
                                  const areAnswersSame =
                                    options.length === answers.length &&
                                    options.every(
                                      (value, index) => value === answers[index]
                                    );

                                  logData.validation_conditions = {
                                    areAnswersSame,
                                    options,
                                    answers,
                                  };

                                  if (areAnswersSame) {
                                    setError(true);
                                    // setSubmitLoading(false); // Stop loader on error
                                    return;
                                  } else {
                                    handleSubmit();
                                    setValidateClicked(true);
                                    // setSubmitLoading(true);
                                  }
                                } else if (
                                  currentAssessment.type === "highlight"
                                ) {
                                  logData.validation_conditions = {
                                    hasSelectedText:
                                      assessmentData[uniqueId]
                                        ?.lastSelectedText !== "",
                                  };

                                  if (
                                    assessmentData[uniqueId]
                                      ?.lastSelectedText === ""
                                  ) {
                                    setError(true);
                                    // setSubmitLoading(false); // Stop loader on error
                                  } else {
                                    handleSubmit();
                                    setValidateClicked(true);
                                    // setSubmitLoading(true);
                                  }
                                } else if (
                                  currentAssessment.type ===
                                  "highlight_multiple"
                                ) {
                                  const highlightRanges =
                                    assessmentData[uniqueId]
                                      ?.highlightMultipleRange || [];
                                  if (highlightRanges.length === 0) {
                                    setError(true);
                                  } else {
                                    handleSubmit();
                                    setValidateClicked(true);
                                  }
                                } else if (
                                  currentAssessment.type ===
                                  "select the answers"
                                ) {
                                  const allAnswered =
                                    currentAssessment.options.every(
                                      (option, index) => {
                                        const dropdownId = option.id;
                                        return (
                                          answers[dropdownId] &&
                                          answers[dropdownId].trim() !== ""
                                        );
                                      }
                                    );

                                  logData.validation_conditions = {
                                    allAnswered,
                                    answers,
                                  };

                                  if (!allAnswered) {
                                    setError(true);
                                    // setSubmitLoading(false); // Stop loader on error
                                    return;
                                  }

                                  handleSubmit();
                                  setValidateClicked(true);
                                  // setSubmitLoading(true);
                                } else if (
                                  currentAssessment.type === "Drag and Drop" ||
                                  currentAssessment.type === "drag and drop_v2"
                                ) {
                                  const hasAtLeastOneAnswer = answers.some(
                                    (col) =>
                                      col.values.some(
                                        (value) => value.trim() !== ""
                                      )
                                  );

                                  logData.validation_conditions = {
                                    hasAtLeastOneAnswer,
                                    answers,
                                  };

                                  if (!hasAtLeastOneAnswer) {
                                    setError(true);
                                    // setSubmitLoading(false); // Stop loader on error
                                    return;
                                  } else {
                                    handleSubmit();
                                    setValidateClicked(true);
                                    // setSubmitLoading(true);
                                  }
                                } else if (answers.length > 0) {
                                  logData.validation_conditions = {
                                    hasAnswers: true,
                                    answers,
                                  };
                                  handleSubmit();
                                  setValidateClicked(true);
                                  // setSubmitLoading(true);
                                } else {
                                  setError(true);
                                  // setSubmitLoading(false); // Stop loader on error
                                }

                                // Save submit log
                                saveSubmitLog(logData);
                              }}
                              disabled={
                                submitLoading ||
                                (typeof timeLeft === "number" &&
                                  timeLeft <= 0) ||
                                finished ||
                                timeOuted
                              }
                            >
                              Submit
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className={style.bodyRight}>
                  {result ? (
                    <>
                      {summaryDetail &&
                        Object.keys(summaryDetail).length > 0 && (
                          <div className={style.summeryContainer}>
                            <div className={style.summeryTopContent}>
                              <div className={style.roundGraph}>
                                <Doughnut
                                  data={{
                                    labels: ["Completed", "Remaining"],
                                    datasets: [
                                      {
                                        data: [
                                          summaryDetail?.percentage || 0,
                                          100 -
                                            (summaryDetail?.percentage || 0),
                                        ],

                                        backgroundColor: [
                                          "#03CD09",
                                          "#3E3D4212",
                                        ],
                                        borderWidth: 0,
                                      },
                                    ],
                                  }}
                                  options={{
                                    cutout: "85%",
                                    plugins: {
                                      legend: {
                                        display: false,
                                      },
                                    },
                                  }}
                                />
                                <div
                                  className={style.graphText}
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    pointerEvents: "none",
                                  }}
                                >
                                  {Math.round(summaryDetail?.percentage || 0)}%
                                </div>
                              </div>
                              <div className={style.summeryTopText}>
                                <p>Your score</p>
                              </div>
                            </div>
                            <div className={style.summeryBottomContent}>
                              <div className={style.summeryBottomData}>
                                <div className={style.summeryBottomDataLeft}>
                                  <span style={{ background: "#00DFC7" }}>
                                    {summaryDetail?.correctAns || 0}
                                  </span>
                                </div>
                                <div className={style.summeryBottomDataRight}>
                                  <p>Correct answers</p>
                                </div>
                              </div>
                              <div className={style.summeryBottomData}>
                                <div className={style.summeryBottomDataLeft}>
                                  <span style={{ background: "#FF2443" }}>
                                    {summaryDetail?.incorrectAns || 0}{" "}
                                  </span>
                                </div>
                                <div className={style.summeryBottomDataRight}>
                                  <p>Wrong answers</p>
                                </div>
                              </div>
                              <div className={style.summeryBottomData}>
                                <div className={style.summeryBottomDataLeft}>
                                  <span style={{ background: "#FFBE00" }}>
                                    {summaryDetail?.skippedQuestions || 0}
                                  </span>
                                </div>
                                <div className={style.summeryBottomDataRight}>
                                  <p>Skipped questions</p>
                                </div>
                              </div>
                              <div className={style.summeryBottomData}>
                                <div className={style.summeryBottomDataLeft}>
                                  <span style={{ background: "#595BDB" }}>
                                    {summaryDetail?.totalQuestions || 0}{" "}
                                  </span>
                                </div>
                                <div className={style.summeryBottomDataRight}>
                                  <p>No. of questions</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </>
                  ) : (
                    <>
                      <div className={style.timeContainerBox}>
                        <div className={style.timeContainer}>
                          <div className={style.timerIcon}>
                            <img src={TimerImage} alt="Timer" />
                          </div>
                          <div className={style.timerText}>
                            <p
                              style={{
                                color: timeLeft <= 120 ? "#FF2443" : "inherit",
                              }}
                            >{`${minutes}:${
                              seconds < 10 ? `0${seconds}` : seconds
                            } mins`}</p>
                          </div>
                        </div>

                        <div className={style.markContainer}>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Answered</p>
                            </div>
                            <div
                              style={{ marginBottom: "8px" }}
                              className={style.markDataRight}
                            >
                              <p>
                                <span>
                                  {
                                    Object.values(assessmentData).filter(
                                      (data) => data.status === "attended"
                                    ).length
                                  }
                                </span>
                                /{totalCount}
                              </p>
                            </div>
                          </div>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Not answered</p>
                            </div>
                            <div className={style.markDataRight}>
                              <p>
                                {
                                  Object.values(assessmentData).filter(
                                    (data) => data.status === "skipped"
                                  ).length
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={style.FinishButton}>
                        <button
                          onClick={() => {
                            handleEndTest();
                          }}
                        >
                          End Test
                        </button>
                      </div>
                      <div className={style.questionPaletteHeader}>
                        <p>Question Palette:</p>
                      </div>
                      <div className={style.questionPalette}>
                        {numbers.map((number, index) => {
                          const questionId = assessment[index]?.unique_id;
                          const status = assessmentData[questionId]?.status;

                          let backgroundColor;
                          if (currentIndex === index) {
                            backgroundColor = "#D9D9D9";
                          } else if (status === "skipped") {
                            backgroundColor = "#818085";
                          } else if (status === "attended") {
                            backgroundColor = "#BEBFFF";
                          } else {
                            backgroundColor = "#FFFFFF";
                          }

                          const numberStyle = {
                            backgroundColor,
                          };

                          return (
                            <div
                              onClick={() => {
                                const uniqueId = currentAssessment?.unique_id;
                                const targetUniqueId =
                                  assessment[number - 1]?.unique_id;

                                // If navigating to a different question, handle the current question state
                                if (uniqueId !== targetUniqueId) {
                                  if (
                                    assessmentData[uniqueId]?.status ===
                                    "viewed"
                                  ) {
                                    setAssessmentData((prev) => ({
                                      ...prev,
                                      [uniqueId]: {
                                        ...prev[uniqueId],
                                        status: "skipped",
                                      },
                                    }));
                                  }

                                  // Reset the current question data if it was only viewed
                                  if (
                                    uniqueId &&
                                    assessmentData[uniqueId] &&
                                    assessmentData[uniqueId]?.status ===
                                      "viewed"
                                  ) {
                                    const currentAssmnt =
                                      assessment[currentIndex];
                                    let resetAnswers;
                                    let resetHighlightContent = "";
                                    let resetLastSelectedText = "";
                                    let resetAcrossClues = [];
                                    let resetDownClues = [];
                                    let highlightMultipleContent = "";
                                    let resetRightOrder = [];

                                    if (
                                      currentAssmnt.type ===
                                        "Match the following" ||
                                      currentAssmnt.type ===
                                        "Match the following with image"
                                    ) {
                                      const filteredLeft = (
                                        currentAssmnt.left || []
                                      ).filter(
                                        (leftData) => leftData.trim() !== ""
                                      );
                                      const filteredRight = (
                                        currentAssmnt.right || []
                                      ).filter(
                                        (rightData) => rightData.trim() !== ""
                                      );
                                      resetAnswers = {
                                        left: filteredLeft,
                                        right: filteredRight,
                                      };
                                      resetRightOrder = filteredRight.map(
                                        (_, i) => i
                                      );
                                    } else if (
                                      currentAssmnt.type === "Rearrange"
                                    ) {
                                      resetAnswers =
                                        currentAssmnt.options || [];
                                    } else if (
                                      currentAssmnt.type === "cross word puzzle"
                                    ) {
                                      resetAnswers = currentAssmnt.options.map(
                                        (row) =>
                                          row.map((cell) => ({
                                            clueID: cell.clueID || "",
                                            clueNumber: cell.clueNumber,
                                            cluevalue: "",
                                            disabled: cell.cluevalue === "",
                                          }))
                                      );

                                      resetAcrossClues = currentAssmnt.left.map(
                                        (clueObj) => ({
                                          id: clueObj.id,
                                          number: clueObj.number,
                                          clue: clueObj.clue,
                                          answer: "",
                                        })
                                      );
                                      resetDownClues = currentAssmnt.right.map(
                                        (clueObj) => ({
                                          id: clueObj.id,
                                          number: clueObj.number,
                                          clue: clueObj.clue,
                                          answer: "",
                                        })
                                      );
                                    } else if (
                                      currentAssmnt.type === "highlight"
                                    ) {
                                      resetHighlightContent =
                                        currentAssmnt.options.replace(
                                          /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                          "$1"
                                        ) || "";
                                      resetHighlightContent =
                                        resetHighlightContent.replace(
                                          /<span[^>]*>(.*?)<\/span>/g,
                                          "$1"
                                        ) || "";

                                      resetLastSelectedText = "";
                                    } else if (
                                      currentAssmnt.type ===
                                      "highlight_multiple"
                                    ) {
                                      highlightMultipleContent =
                                        currentAssmnt.options.replace(
                                          /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                          "$1"
                                        );

                                      highlightMultipleContent =
                                        highlightMultipleContent.replace(
                                          /<span[^>]*>(.*?)<\/span>/g,
                                          "$1"
                                        );
                                      resetAnswers = [];
                                    } else if (
                                      currentAssmnt.type === "Drag and Drop" ||
                                      currentAssmnt.type === "drag and drop_v2"
                                    ) {
                                      const updatedAnswer =
                                        currentAssmnt.answer.map((item) => {
                                          return {
                                            ...item,
                                            values: item.values.map(() => ""),
                                          };
                                        });
                                      resetAnswers = updatedAnswer;
                                    } else {
                                      resetAnswers = [];
                                    }

                                    setAssessmentData((prev) => ({
                                      ...prev,
                                      [uniqueId]: {
                                        ...prev[uniqueId],
                                        answers: resetAnswers,
                                        rightOrder: resetRightOrder,
                                        highlightContent: resetHighlightContent,
                                        lastSelectedText: resetLastSelectedText,
                                        cluesAcross: resetAcrossClues,
                                        cluesDown: resetDownClues,
                                        previousRange: null,
                                        highlightMultipleContent:
                                          highlightMultipleContent,
                                        highlightMultipleRange: [],
                                      },
                                    }));
                                    setSelectedOptions((prev) => {
                                      const { [uniqueId]: _, ...rest } = prev;
                                      return rest;
                                    });
                                  }
                                }

                                setCurrentIndex(number - 1);
                                setValidateClicked(false); // Reset validateClicked on palette click
                                setStartTime(Date.now());
                                setSubmitLoading(false);
                              }}
                              key={number}
                              className={style.number}
                              style={numberStyle}
                            >
                              <p> {number}</p>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div className={style.info}>
                <p>{apiError ? apiError : "No Daily Drill found"}</p>
              </div>
            )}
          </>
        )}
      </div>
      {finishPopup ? (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            <div className={style.popupText}>
              <p>Are you sure you want to end the test?</p>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={() => {
                  setFinishPopup(false);
                }}
              >
                No
              </button>
              <button
                className={style.yesButton}
                onClick={(e) => {
                  e.preventDefault();
                  clearInterval(timerRef.current);
                  assessmentSummary();
                  setFinished(true);
                  setTimeRunning(false);
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {achievementPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.achievementPopupSection}>
              <div className={style.achievementPopupHeder}>
                <h2>Hooray!</h2>
                <p>
                  You just unlocked{" "}
                  <span>{carouselData.length} Achievements</span>
                </p>
              </div>
              <div className={style.achievementCarousel}>
                <div
                  className={style.carouselTrackContainer}
                  style={{
                    overflowX: carouselData.length > 1 ? "auto" : "hidden",
                    display: "flex",
                    justifyContent:
                      carouselData.length === 1 ? "center" : "flex-start",
                  }}
                >
                  <div
                    className={style.carouselTrack}
                    style={{
                      transform: "none",
                    }}
                  >
                    {carouselData.map((item, index) => (
                      <div key={index} className={style.carouselSlide}>
                        <div className={style.achievementPopupImage}>
                          <img src={item.active_img} alt={item.name} />
                        </div>
                        <div className={style.carouselText}>
                          <h3>{item.name}</h3>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setAchievementPopup(false);
                  if (points > 0 || points > "0") {
                    setCollectPopup(true);
                  }
                }}
              >
                OK
              </button>
            </div>
          </div>
        </>
      )}
      {collectPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.collectPopupHeader}>
              <p>Congratulations</p>
            </div>
            <div className={style.collectPopupImageContainer}>
              <div className={style.collectPopupImage}>
                <img src={Coins} alt="Reward" />
              </div>
              <div className={style.collectPopupLottie}>
                <Lottie
                  animationData={coinsLottie}
                  loop={true}
                  duration
                  autoplay
                />
              </div>
            </div>
            <div className={style.collectPopupText}>
              <span>You receive</span>
              <h3>{points} xp</h3>
              {/* <p>500 xp for completing a module within 6 weeks</p>
            <p>100 xp for scoring above 85%</p> */}
            </div>
            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setCollectPopup(false);
                  const token = userDetails && userDetails.auth_token; // Assuming `key` is the token
                  dispatch(
                    fetchUserDetails({
                      userid: userDetails && userDetails._id?.$oid,
                      token,
                    })
                  );
                }}
              >
                Collect All
              </button>
            </div>
          </div>
        </>
      )}
      {coinsAnimation && (
               <>
                <div className={style.popupOverlay}></div>
                <div className={style.achievementPopup}>
                  <div className={style.collectPopupHeader}>
                    <p>Congratulations</p>
                  </div>
                  <div className={style.collectPopupImageContainer}>
                    <div className={style.collectPopupImage}>
                      <img src={Coins} alt="Reward" />
                    </div>
                    <div className={style.collectPopupLottie}>
                      <Lottie
                        animationData={coinsLottie}
                        loop={true}
                        duration
                        autoplay
                      />
                    </div>
                  </div>
                  <div className={style.collectPopupText}>
                    <span>You receive</span>
                    <h3>{points} xp</h3>
                  </div>
                  <div className={style.achievementPopupButton}>
                    <button
                      onClick={() => {
                        setCoinsAnimation(false);
                        const token = userDetails && userDetails.auth_token; 
                        dispatch(
                          fetchUserDetails({
                            userid: userDetails && userDetails._id?.$oid,
                            token,
                          })
                        );
                      }}
                    >
                      Collect All
                    </button>
                  </div>
                </div>
              </>
            )
            }
    </div>
  );
};

export default DailyDrill;
